import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  Unit_instanceat14thlj150z as Unit_instance,
  contentEquals2jbsaphs7gxql as contentEquals,
  contentHashCode33l4yznfe2pz3 as contentHashCode,
  intArrayIterator15bt84fheeonh as intArrayIterator,
  protoOf180f3jzyo7rfj as protoOf,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  VOID7hggqo3abtya as VOID,
  contentEquals379bkuxwxaiqz as contentEquals_0,
  contentHashCode2dpr73siofp13 as contentHashCode_0,
  floatArrayIteratortsocm2kbztk as floatArrayIterator,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  println2shhhgwwt4c61 as println,
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
  toString1pkumu07cwy4m as toString,
  Long2qws0ah9gnpki as Long,
  toLongw1zpgk99d84b as toLong,
  reverse2o3etdk6ug8y7 as reverse,
  copyOfq9pcgcgbldck as copyOf,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  isFloatArrayjjscnqphw92j as isFloatArray,
  createThis2j2avj17cvnv2 as createThis,
  takeg3iw3d2yd8b4 as take,
  equals2au1ep9vhcato as equals,
  KtList3hktaavzmj137 as KtList,
  isInterface3d6p8outrmvmk as isInterface,
  StringBuildermazzzhj6kkai as StringBuilder,
  _Char___init__impl__6a9atx367vrx0avsvbg as _Char___init__impl__6a9atx,
  Collection1k04j3hzsbod0 as Collection,
  isIntArrayeijsubfngq38 as isIntArray,
  copyOf3rutauicler23 as copyOf_0,
  IndexOutOfBoundsException1qfr429iumro0 as IndexOutOfBoundsException,
  take8rd02inxauy8 as take_0,
  copyOfgossjg6lh6js as copyOf_1,
  isDoubleArray1wyh4nyf7pjxn as isDoubleArray,
  takei63g8tyo7wy9 as take_1,
  asList2ho2pewtsfvv as asList,
  compareTo3ankvs086tmwq as compareTo,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  fillArrayVali8eppxapiek4 as fillArrayVal,
  isArray1hxjqtqy632bc as isArray,
  toList3jhuyej2anx2q as toList,
  ArrayList3it5z8td81qkl as ArrayList,
  collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault,
  to2cs3ny02qtbcb as to,
  KtMap140uvy3s5zad8 as KtMap,
  hashCodeq5arwsb9dgti as hashCode,
  MutableIterablez3x4ksk1fmrm as MutableIterable,
  AbstractMutableSetthfi6jds1k2h as AbstractMutableSet,
  LinkedHashSet2tkztfx86kyx2 as LinkedHashSet,
  toMutableSetjdpdbr9jsqq8 as toMutableSet,
  until1jbpn0z3f8lbg as until,
  NoSuchElementException679xzhnp5bpj as NoSuchElementException,
  joinToString1cxrrlmo0chqs as joinToString,
  Iterable1y3qizuf89iou as Iterable,
  copyOf2ng0t8oizk6it as copyOf_2,
  toString30pk9tzaqopn as toString_0,
  numberToInt1ygmcfwhs2fkq as numberToInt,
  FunctionAdapter3lcrrz3moet5b as FunctionAdapter,
  Comparator2b3maoeh98xtg as Comparator,
  reversed3cb5fwpceefdb as reversed,
  NotImplementedErrorfzlkpv14xxr8 as NotImplementedError,
  toSet2orjxp16sotqu as toSet,
  contentEqualsaf55p28mnw74 as contentEquals_1,
  contentHashCode2i020q5tbeh2s as contentHashCode_1,
  throwUninitializedPropertyAccessExceptionyynx7gkm73wd as throwUninitializedPropertyAccessException,
  toRawBits2035dtuolth0v as toRawBits,
  LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap,
  step18s9qzr5xwxat as step,
  arrayCopytctsywo3h7gj as arrayCopy,
  round2mrvepag8eey0 as round,
  toList383f556t1dixk as toList_0,
} from './kotlin-kotlin-stdlib.mjs';
import {
  ilog23dbvpk38jf7rc as ilog2,
  umod164hvijxhfi8p as umod,
  ilog2Ceil34a3ub1n8578t as ilog2Ceil,
  isAlmostEquals$default2ib7nwup21mfy as isAlmostEquals$default,
  roundDecimalPlaces1x32iuyd1l8m5 as roundDecimalPlaces,
  appendNice3hizhj9kone09 as appendNice,
  appendGenericArray5krccch8fjd0 as appendGenericArray,
} from './korlibs-math-core-root-korlibs-math-core.mjs';
import {
  listIterator247sl90ooi4qv as listIterator,
  DoubleList2honu8rif2roh as DoubleList,
  fastArrayListOf1rdodhrpn0q8y as fastArrayListOf,
  FastArrayListw5fr1wlp4slq as FastArrayList,
  Mixin3lmkm5hum2vdj as Mixin,
} from './korlibs-datastructure-core-root-korlibs-datastructure-core.mjs';
import {
  NonRecursiveLock2vf7fkhp857q as NonRecursiveLock,
  Lock5n7hh3dgcidl as Lock,
} from './korlibs-concurrent-root-korlibs-concurrent.mjs';
import {
  Vector2D378fe5rov8fgw as Vector2D,
  IDoubleVectorListoa05cse3he2p as IDoubleVectorList,
  IPointListz7raskb2mrxa as IPointList,
  isNotEmptyrwyeygz7izwg as isNotEmpty,
  isAlmostEquals2qd88bwpjj4z5 as isAlmostEquals,
  containsAll194lepx84fvib as containsAll,
  indexOf3tp8bzbv46hci as indexOf,
  iterator1sm8hwbj0nmg8 as iterator,
  listIteratorrk3szyua4uzm as listIterator_0,
  listIterator3ooh2yjav3kr9 as listIterator_1,
  subList2funs4qwcrhhq as subList,
} from './korlibs-math-vector-root-korlibs-math-vector.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
class Companion {}
class IArray2 {}
function inside(x, y) {
  return x >= 0 && y >= 0 && x < this.x2p() && y < this.y2p();
}
function getAt(x, y) {
  return this.f2q(x, y) ? this.m10(indexOr(this, x, y)) : this.m10(0);
}
function asString() {
  var tmp = until(0, this.y2p());
  return joinToString(tmp, '\n', VOID, VOID, VOID, VOID, IArray2$asString$lambda(this));
}
class IntIArray2 {}
function get(x, y) {
  return this.a2q(indexOr(this, x, y));
}
function set(x, y, value) {
  return this.b2q(indexOr(this, x, y), value);
}
function getAt_0(idx) {
  return this.a2q(idx);
}
class IntArray2 {
  constructor(width, height, data) {
    this.u2p_1 = width;
    this.v2p_1 = height;
    this.w2p_1 = data;
    Companion_instance_4.z2p(this.x2p(), this.y2p(), this.w2p_1.length);
  }
  x2p() {
    return this.u2p_1;
  }
  y2p() {
    return this.v2p_1;
  }
  equals(other) {
    var tmp;
    var tmp_0;
    var tmp_1;
    if (other instanceof IntArray2) {
      tmp_1 = this.x2p() === other.x2p();
    } else {
      tmp_1 = false;
    }
    if (tmp_1) {
      tmp_0 = this.y2p() === other.y2p();
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = contentEquals(this.w2p_1, other.w2p_1);
    } else {
      tmp = false;
    }
    return tmp;
  }
  a2q(idx) {
    // Inline function 'kotlin.collections.getOrElse' call
    var this_0 = this.w2p_1;
    // Inline function 'kotlin.contracts.contract' call
    var tmp;
    if (0 <= idx ? idx <= (this_0.length - 1 | 0) : false) {
      tmp = this_0[idx];
    } else {
      // Inline function 'korlibs.datastructure.IntArray2.getFast.<anonymous>' call
      tmp = this.w2p_1[0];
    }
    return tmp;
  }
  b2q(idx, value) {
    if (0 <= idx ? idx <= (this.w2p_1.length - 1 | 0) : false) {
      this.w2p_1[idx] = value;
    }
  }
  hashCode() {
    return (this.x2p() + this.y2p() | 0) + contentHashCode(this.w2p_1) | 0;
  }
  a1() {
    return intArrayIterator(this.w2p_1);
  }
  toString() {
    return this.c2q();
  }
}
class Companion_0 {}
class FloatIArray2 {}
function get_0(x, y) {
  return this.a2q(indexOr(this, x, y));
}
function set_0(x, y, value) {
  return this.j2q(indexOr(this, x, y), value);
}
function getAt_1(idx) {
  return this.a2q(idx);
}
class FloatArray2 {
  constructor(width, height, data) {
    this.g2q_1 = width;
    this.h2q_1 = height;
    this.i2q_1 = data;
    Companion_instance_4.z2p(this.x2p(), this.y2p(), this.i2q_1.length);
  }
  x2p() {
    return this.g2q_1;
  }
  y2p() {
    return this.h2q_1;
  }
  equals(other) {
    var tmp;
    var tmp_0;
    var tmp_1;
    if (other instanceof FloatArray2) {
      tmp_1 = this.x2p() === other.x2p();
    } else {
      tmp_1 = false;
    }
    if (tmp_1) {
      tmp_0 = this.y2p() === other.y2p();
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = contentEquals_0(this.i2q_1, other.i2q_1);
    } else {
      tmp = false;
    }
    return tmp;
  }
  a2q(idx) {
    // Inline function 'kotlin.collections.getOrElse' call
    var this_0 = this.i2q_1;
    // Inline function 'kotlin.contracts.contract' call
    var tmp;
    if (0 <= idx ? idx <= (this_0.length - 1 | 0) : false) {
      tmp = this_0[idx];
    } else {
      // Inline function 'korlibs.datastructure.FloatArray2.getFast.<anonymous>' call
      tmp = 0.0;
    }
    return tmp;
  }
  j2q(idx, value) {
    if (0 <= idx ? idx <= (this.i2q_1.length - 1 | 0) : false) {
      this.i2q_1[idx] = value;
    }
  }
  hashCode() {
    return (this.x2p() + this.y2p() | 0) + contentHashCode_0(this.i2q_1) | 0;
  }
  a1() {
    return floatArrayIterator(this.i2q_1);
  }
  toString() {
    return this.c2q();
  }
}
class ByteArrayDeque {
  constructor(initialBits, allowGrow) {
    initialBits = initialBits === VOID ? 10 : initialBits;
    allowGrow = allowGrow === VOID ? true : allowGrow;
    this.t2q_1 = initialBits;
    this.u2q_1 = allowGrow;
    this.v2q_1 = new RingBuffer(this.t2q_1);
    this.w2q_1 = new Int8Array(1024);
    this.x2q_1 = new Long(0, 0);
    this.y2q_1 = new Long(0, 0);
  }
  m16() {
    return this.v2q_1.s2q_1;
  }
  n16(buffer, offset, size) {
    ensureWrite(this, size);
    var out = this.v2q_1.n16(buffer, offset, size);
    if (out > 0) {
      var tmp = this;
      // Inline function 'kotlin.Long.plus' call
      tmp.x2q_1 = this.x2q_1.a4(toLong(out));
    }
    return out;
  }
  a2r(buffer, offset, size, $super) {
    offset = offset === VOID ? 0 : offset;
    size = size === VOID ? buffer.length - offset | 0 : size;
    return $super === VOID ? this.n16(buffer, offset, size) : $super.n16.call(this, buffer, offset, size);
  }
  d17(count) {
    return this.v2q_1.d17(count);
  }
  c17(buffer, offset, size) {
    return this.v2q_1.c17(buffer, offset, size);
  }
  m3() {
    this.v2q_1.m3();
  }
  hashCode() {
    return this.v2q_1.p16();
  }
  equals(other) {
    var tmp;
    if (other instanceof ByteArrayDeque) {
      tmp = this.v2q_1.equals(other.v2q_1);
    } else {
      tmp = false;
    }
    return tmp;
  }
}
class ShortArrayDeque {
  constructor(initialBits) {
    initialBits = initialBits === VOID ? 10 : initialBits;
    this.k2r_1 = initialBits;
    this.l2r_1 = new ShortRingBuffer(this.k2r_1);
    this.m2r_1 = new Int16Array(1024);
    this.n2r_1 = new Long(0, 0);
    this.o2r_1 = new Long(0, 0);
  }
  m16() {
    return this.l2r_1.i2r_1;
  }
  q2r(buffer, offset, size) {
    var out = ensureWrite_0(this, size).l2r_1.q2r(buffer, offset, size);
    if (out > 0) {
      var tmp = this;
      // Inline function 'kotlin.Long.plus' call
      tmp.n2r_1 = this.n2r_1.a4(toLong(out));
    }
    return out;
  }
  p2r(buffer, offset, size) {
    var out = this.l2r_1.p2r(buffer, offset, size);
    if (out > 0) {
      var tmp = this;
      // Inline function 'kotlin.Long.plus' call
      tmp.o2r_1 = this.o2r_1.a4(toLong(out));
    }
    return out;
  }
  m3() {
    this.l2r_1.m3();
  }
  r2r() {
    this.p2r(this.m2r_1, 0, 1);
    return this.m2r_1[0];
  }
  s2r(value) {
    this.m2r_1[0] = value;
    this.q2r(this.m2r_1, 0, 1);
  }
  hashCode() {
    return this.l2r_1.p16();
  }
  equals(other) {
    var tmp;
    if (other instanceof ShortArrayDeque) {
      tmp = this.l2r_1.equals(other.l2r_1);
    } else {
      tmp = false;
    }
    return tmp;
  }
}
class Companion_1 {}
class FloatArrayList {
  static v2r(capacity) {
    capacity = capacity === VOID ? 7 : capacity;
    var $this = createThis(this);
    var tmp = $this;
    var tmp_0 = new Float32Array(capacity);
    tmp.t2r_1 = isFloatArray(tmp_0) ? tmp_0 : THROW_CCE();
    $this.u2r_1 = 0;
    return $this;
  }
  tv(value) {
    ensure(this, value);
    this.u2r_1 = value;
  }
  e1() {
    return this.u2r_1;
  }
  static w2r(other) {
    var $this = this.v2r();
    $this.x2r(other);
    return $this;
  }
  m3() {
    this.u2r_1 = 0;
  }
  y2r(v0, v1, v2, v3) {
    ensure(this, 4);
    var tmp = this.t2r_1;
    var _unary__edvuaz = this.u2r_1;
    this.u2r_1 = _unary__edvuaz + 1 | 0;
    tmp[_unary__edvuaz] = v0;
    var tmp_0 = this.t2r_1;
    var _unary__edvuaz_0 = this.u2r_1;
    this.u2r_1 = _unary__edvuaz_0 + 1 | 0;
    tmp_0[_unary__edvuaz_0] = v1;
    var tmp_1 = this.t2r_1;
    var _unary__edvuaz_1 = this.u2r_1;
    this.u2r_1 = _unary__edvuaz_1 + 1 | 0;
    tmp_1[_unary__edvuaz_1] = v2;
    var tmp_2 = this.t2r_1;
    var _unary__edvuaz_2 = this.u2r_1;
    this.u2r_1 = _unary__edvuaz_2 + 1 | 0;
    tmp_2[_unary__edvuaz_2] = v3;
  }
  z2r(values, offset, length) {
    ensure(this, length);
    var tmp = Memory_instance;
    tmp.a2s(isFloatArray(values) ? values : THROW_CCE(), offset, this.t2r_1, this.e1(), length);
    this.tv(this.e1() + length | 0);
  }
  x2r(values, offset, length, $super) {
    offset = offset === VOID ? 0 : offset;
    length = length === VOID ? values.length : length;
    var tmp;
    if ($super === VOID) {
      this.z2r(values, offset, length);
      tmp = Unit_instance;
    } else {
      tmp = $super.z2r.call(this, values, offset, length);
    }
    return tmp;
  }
  m10(index) {
    return this.t2r_1[index];
  }
  a1() {
    return this.d3(0);
  }
  b2s(element) {
    var inductionVariable = 0;
    var last = this.u2r_1;
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (this.t2r_1[n] === element)
          return true;
      }
       while (inductionVariable < last);
    return false;
  }
  c2s(elements) {
    var _iterator__ex2g4s = elements.a1();
    while (_iterator__ex2g4s.b1()) {
      var e = _iterator__ex2g4s.c1();
      if (!this.b2s(e))
        return false;
    }
    return true;
  }
  a3(elements) {
    return this.c2s(elements);
  }
  g1() {
    return this.e1() === 0;
  }
  d2s() {
    return copyOf(this.t2r_1, this.u2r_1);
  }
  d3(index) {
    return take(this.t2r_1, this.u2r_1).d3(index);
  }
  hashCode() {
    return contentHashCode_2(this.t2r_1, 0, this.e1());
  }
  equals(other) {
    if (other instanceof FloatArrayList)
      return this.e1() === other.e1() && contentEquals_2(this.t2r_1, other.t2r_1, 0, this.e1());
    if (!(other == null) ? isInterface(other, KtList) : false)
      return equals(other, this);
    return false;
  }
  toString() {
    // Inline function 'kotlin.also' call
    var this_0 = StringBuilder.jc(2 + imul(5, this.e1()) | 0);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.datastructure.FloatArrayList.toString.<anonymous>' call
    this_0.fc(_Char___init__impl__6a9atx(91));
    var inductionVariable = 0;
    var last = this.e1();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (!(n === 0)) {
          this_0.ec(', ');
        }
        this_0.ih(this.m10(n));
      }
       while (inductionVariable < last);
    this_0.fc(_Char___init__impl__6a9atx(93));
    return this_0.toString();
  }
}
class Companion_2 {}
class IntArrayList {
  static g2s(capacity) {
    capacity = capacity === VOID ? 7 : capacity;
    var $this = createThis(this);
    var tmp = $this;
    var tmp_0 = new Int32Array(capacity);
    tmp.e2s_1 = isIntArray(tmp_0) ? tmp_0 : THROW_CCE();
    $this.f2s_1 = 0;
    return $this;
  }
  tv(value) {
    this.h2s(value);
    this.f2s_1 = value;
  }
  e1() {
    return this.f2s_1;
  }
  static i2s(other) {
    var $this = this.g2s();
    $this.j2s(other);
    return $this;
  }
  static k2s(other) {
    var $this = this.g2s();
    $this.l2s(other);
    return $this;
  }
  h2s(count) {
    if ((this.f2s_1 + count | 0) > this.e2s_1.length) {
      var tmp = this;
      var tmp_0 = this.e2s_1;
      // Inline function 'kotlin.math.max' call
      var a = this.f2s_1 + count | 0;
      var b = imul(this.e2s_1.length, 3);
      var tmp$ret$0 = Math.max(a, b);
      var tmp_1 = copyOf_0(tmp_0, tmp$ret$0);
      tmp.e2s_1 = isIntArray(tmp_1) ? tmp_1 : THROW_CCE();
    }
  }
  m3() {
    this.f2s_1 = 0;
  }
  m2s(v0) {
    this.h2s(1);
    var tmp = this.e2s_1;
    var _unary__edvuaz = this.f2s_1;
    this.f2s_1 = _unary__edvuaz + 1 | 0;
    tmp[_unary__edvuaz] = v0;
  }
  n2s(value) {
    return this.m2s(value);
  }
  o2s(value) {
    return this.j2s(value);
  }
  p2s(values, offset, length) {
    this.h2s(length);
    var tmp = Memory_instance;
    tmp.q2s(isIntArray(values) ? values : THROW_CCE(), offset, this.e2s_1, this.e1(), length);
    this.tv(this.e1() + length | 0);
  }
  l2s(values, offset, length, $super) {
    offset = offset === VOID ? 0 : offset;
    length = length === VOID ? values.length : length;
    var tmp;
    if ($super === VOID) {
      this.p2s(values, offset, length);
      tmp = Unit_instance;
    } else {
      tmp = $super.p2s.call(this, values, offset, length);
    }
    return tmp;
  }
  j2s(values) {
    return this.p2s(values.e2s_1, 0, values.e1());
  }
  d1(index) {
    return this.e2s_1[index];
  }
  m10(index) {
    return this.e2s_1[index];
  }
  r2s(index, value) {
    if (index >= this.f2s_1) {
      this.h2s(index + 1 | 0);
      this.f2s_1 = index + 1 | 0;
    }
    this.e2s_1[index] = value;
  }
  a1() {
    return this.d3(0);
  }
  rp(element) {
    var inductionVariable = 0;
    var last = this.f2s_1;
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (this.e2s_1[n] === element)
          return true;
      }
       while (inductionVariable < last);
    return false;
  }
  s2s(elements) {
    var _iterator__ex2g4s = elements.a1();
    while (_iterator__ex2g4s.b1()) {
      var e = _iterator__ex2g4s.c1();
      if (!this.rp(e))
        return false;
    }
    return true;
  }
  a3(elements) {
    return this.s2s(elements);
  }
  g1() {
    return this.e1() === 0;
  }
  r2f() {
    return !(this.e1() === 0);
  }
  xk() {
    var tmp;
    if (this.g1()) {
      throw IndexOutOfBoundsException.pe();
    } else {
      tmp = this.e2s_1[0];
    }
    return tmp;
  }
  t2s() {
    var tmp;
    if (this.g1()) {
      throw IndexOutOfBoundsException.pe();
    } else {
      tmp = this.e2s_1[this.f2s_1 - 1 | 0];
    }
    return tmp;
  }
  u2s(index, value) {
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.datastructure.IntArrayList.insertAt.<anonymous>' call
    this.h2s(1);
    if (this.r2f()) {
      Memory_instance.q2s(this.e2s_1, index, this.e2s_1, index + 1 | 0, this.f2s_1 - index | 0);
    }
    this.e2s_1[index] = value;
    this.f2s_1 = this.f2s_1 + 1 | 0;
    return this;
  }
  v2s(indexA, indexB) {
    var l = this.m10(indexA);
    var r = this.m10(indexB);
    this.r2s(indexA, r);
    this.r2s(indexB, l);
  }
  w2s(index, count) {
    if (index < 0 || index >= this.f2s_1 || (index + count | 0) > this.f2s_1)
      throw IndexOutOfBoundsException.pe();
    var out = this.e2s_1[index];
    if (count > 0) {
      if (index < (this.f2s_1 - count | 0)) {
        Memory_instance.q2s(this.e2s_1, index + count | 0, this.e2s_1, index, (this.f2s_1 - index | 0) - count | 0);
      }
      this.f2s_1 = this.f2s_1 - count | 0;
    }
    return out;
  }
  x2s() {
    return copyOf_0(this.e2s_1, this.f2s_1);
  }
  d3(index) {
    return take_0(this.e2s_1, this.f2s_1).d3(index);
  }
  hashCode() {
    return contentHashCode_3(this.e2s_1, 0, this.e1());
  }
  equals(other) {
    if (other instanceof IntArrayList)
      return this.e1() === other.e1() && contentEquals_3(this.e2s_1, other.e2s_1, 0, this.e1());
    if (!(other == null) ? isInterface(other, KtList) : false)
      return equals(other, this);
    return false;
  }
  toString() {
    // Inline function 'kotlin.also' call
    var this_0 = StringBuilder.jc(2 + imul(5, this.e1()) | 0);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.datastructure.IntArrayList.toString.<anonymous>' call
    this_0.fc(_Char___init__impl__6a9atx(91));
    var inductionVariable = 0;
    var last = this.e1();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (!(n === 0)) {
          this_0.ec(', ');
        }
        this_0.gh(this.m10(n));
      }
       while (inductionVariable < last);
    this_0.fc(_Char___init__impl__6a9atx(93));
    return this_0.toString();
  }
}
class Companion_3 {}
class DoubleArrayList {
  static a2t(capacity) {
    capacity = capacity === VOID ? 7 : capacity;
    var $this = createThis(this);
    var tmp = $this;
    var tmp_0 = new Float64Array(capacity);
    tmp.y2s_1 = isDoubleArray(tmp_0) ? tmp_0 : THROW_CCE();
    $this.z2s_1 = 0;
    return $this;
  }
  tv(value) {
    ensure_0(this, value);
    this.z2s_1 = value;
  }
  e1() {
    return this.z2s_1;
  }
  static b2t(other) {
    var $this = this.a2t();
    $this.c2t(other);
    return $this;
  }
  static d2t(other) {
    var $this = this.a2t();
    $this.e2t(other);
    return $this;
  }
  m3() {
    this.z2s_1 = 0;
  }
  j12(v0) {
    ensure_0(this, 1);
    var tmp = this.y2s_1;
    var _unary__edvuaz = this.z2s_1;
    this.z2s_1 = _unary__edvuaz + 1 | 0;
    tmp[_unary__edvuaz] = v0;
  }
  f2t(v0, v1) {
    ensure_0(this, 2);
    var tmp = this.y2s_1;
    var _unary__edvuaz = this.z2s_1;
    this.z2s_1 = _unary__edvuaz + 1 | 0;
    tmp[_unary__edvuaz] = v0;
    var tmp_0 = this.y2s_1;
    var _unary__edvuaz_0 = this.z2s_1;
    this.z2s_1 = _unary__edvuaz_0 + 1 | 0;
    tmp_0[_unary__edvuaz_0] = v1;
  }
  g2t(v0, v1, v2, v3) {
    ensure_0(this, 4);
    var tmp = this.y2s_1;
    var _unary__edvuaz = this.z2s_1;
    this.z2s_1 = _unary__edvuaz + 1 | 0;
    tmp[_unary__edvuaz] = v0;
    var tmp_0 = this.y2s_1;
    var _unary__edvuaz_0 = this.z2s_1;
    this.z2s_1 = _unary__edvuaz_0 + 1 | 0;
    tmp_0[_unary__edvuaz_0] = v1;
    var tmp_1 = this.y2s_1;
    var _unary__edvuaz_1 = this.z2s_1;
    this.z2s_1 = _unary__edvuaz_1 + 1 | 0;
    tmp_1[_unary__edvuaz_1] = v2;
    var tmp_2 = this.y2s_1;
    var _unary__edvuaz_2 = this.z2s_1;
    this.z2s_1 = _unary__edvuaz_2 + 1 | 0;
    tmp_2[_unary__edvuaz_2] = v3;
  }
  h2t(v0, v1, v2, v3, v4, v5) {
    ensure_0(this, 6);
    var tmp = this.y2s_1;
    var _unary__edvuaz = this.z2s_1;
    this.z2s_1 = _unary__edvuaz + 1 | 0;
    tmp[_unary__edvuaz] = v0;
    var tmp_0 = this.y2s_1;
    var _unary__edvuaz_0 = this.z2s_1;
    this.z2s_1 = _unary__edvuaz_0 + 1 | 0;
    tmp_0[_unary__edvuaz_0] = v1;
    var tmp_1 = this.y2s_1;
    var _unary__edvuaz_1 = this.z2s_1;
    this.z2s_1 = _unary__edvuaz_1 + 1 | 0;
    tmp_1[_unary__edvuaz_1] = v2;
    var tmp_2 = this.y2s_1;
    var _unary__edvuaz_2 = this.z2s_1;
    this.z2s_1 = _unary__edvuaz_2 + 1 | 0;
    tmp_2[_unary__edvuaz_2] = v3;
    var tmp_3 = this.y2s_1;
    var _unary__edvuaz_3 = this.z2s_1;
    this.z2s_1 = _unary__edvuaz_3 + 1 | 0;
    tmp_3[_unary__edvuaz_3] = v4;
    var tmp_4 = this.y2s_1;
    var _unary__edvuaz_4 = this.z2s_1;
    this.z2s_1 = _unary__edvuaz_4 + 1 | 0;
    tmp_4[_unary__edvuaz_4] = v5;
  }
  i2t(value) {
    return this.j12(value);
  }
  j2t(value) {
    return this.c2t(value);
  }
  k2t(values, offset, length) {
    ensure_0(this, length);
    var tmp = Memory_instance;
    tmp.l2t(isDoubleArray(values) ? values : THROW_CCE(), offset, this.y2s_1, this.e1(), length);
    this.tv(this.e1() + length | 0);
  }
  e2t(values, offset, length, $super) {
    offset = offset === VOID ? 0 : offset;
    length = length === VOID ? values.length : length;
    var tmp;
    if ($super === VOID) {
      this.k2t(values, offset, length);
      tmp = Unit_instance;
    } else {
      tmp = $super.k2t.call(this, values, offset, length);
    }
    return tmp;
  }
  c2t(values) {
    return this.k2t(values.y2s_1, 0, values.e1());
  }
  d1(index) {
    return this.y2s_1[index];
  }
  m10(index) {
    return this.y2s_1[index];
  }
  m2t(index, value) {
    if (index >= this.z2s_1) {
      ensure_0(this, index + 1 | 0);
      this.z2s_1 = index + 1 | 0;
    }
    this.y2s_1[index] = value;
  }
  a1() {
    return this.d3(0);
  }
  n2t(element) {
    var inductionVariable = 0;
    var last = this.z2s_1;
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (this.y2s_1[n] === element)
          return true;
      }
       while (inductionVariable < last);
    return false;
  }
  p10(elements) {
    var _iterator__ex2g4s = elements.a1();
    while (_iterator__ex2g4s.b1()) {
      var e = _iterator__ex2g4s.c1();
      if (!this.n2t(e))
        return false;
    }
    return true;
  }
  a3(elements) {
    return this.p10(elements);
  }
  g1() {
    return this.e1() === 0;
  }
  v2s(indexA, indexB) {
    var l = this.m10(indexA);
    var r = this.m10(indexB);
    this.m2t(indexA, r);
    this.m2t(indexB, l);
  }
  r3(index) {
    return this.w2s(index, 1);
  }
  w2s(index, count) {
    if (index < 0 || index >= this.z2s_1 || (index + count | 0) > this.z2s_1)
      throw IndexOutOfBoundsException.pe();
    var out = this.y2s_1[index];
    if (count > 0) {
      if (index < (this.z2s_1 - count | 0)) {
        Memory_instance.l2t(this.y2s_1, index + count | 0, this.y2s_1, index, (this.z2s_1 - index | 0) - count | 0);
      }
      this.z2s_1 = this.z2s_1 - count | 0;
    }
    return out;
  }
  n10() {
    return copyOf_1(this.y2s_1, this.z2s_1);
  }
  d3(index) {
    return take_1(this.y2s_1, this.z2s_1).d3(index);
  }
  e3(fromIndex, toIndex) {
    // Inline function 'kotlin.collections.asList' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$1 = this.y2s_1;
    return asList(tmp$ret$1).e3(fromIndex, toIndex);
  }
  o10() {
    return DoubleArrayList.b2t(this);
  }
  hashCode() {
    return contentHashCode_4(this.y2s_1, 0, this.e1());
  }
  equals(other) {
    if (other instanceof DoubleArrayList)
      return this.e1() === other.e1() && contentEquals_4(this.y2s_1, other.y2s_1, 0, this.e1());
    if (!(other == null) ? isInterface(other, KtList) : false)
      return equals(other, this);
    return false;
  }
  toString() {
    // Inline function 'kotlin.also' call
    var this_0 = StringBuilder.jc(2 + imul(5, this.e1()) | 0);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.datastructure.DoubleArrayList.toString.<anonymous>' call
    this_0.fc(_Char___init__impl__6a9atx(91));
    var inductionVariable = 0;
    var last = this.e1();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (!(n === 0)) {
          this_0.ec(', ');
        }
        this_0.jh(this.m10(n));
      }
       while (inductionVariable < last);
    this_0.fc(_Char___init__impl__6a9atx(93));
    return this_0.toString();
  }
}
class SortOps {
  t2t(subject, indexL, indexR) {
    var inductionVariable = indexR;
    var last = indexL + 1 | 0;
    if (last <= inductionVariable)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + -1 | 0;
        this.s2t(subject, n - 1 | 0, n);
      }
       while (!(n === last));
  }
  o2t(subject, indexL, indexR) {
    var count = (indexR - indexL | 0) + 1 | 0;
    var inductionVariable = 0;
    var last = count / 2 | 0;
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        this.s2t(subject, indexL + n | 0, indexR - n | 0);
      }
       while (inductionVariable < last);
  }
}
class DoubleArrayListSortOps extends SortOps {
  constructor() {
    DoubleArrayListSortOps_instance = null;
    super();
    DoubleArrayListSortOps_instance = this;
  }
  p2t(subject, l, r) {
    return compareTo(subject.m10(l), subject.m10(r));
  }
  q2t(subject, l, r) {
    return this.p2t(subject instanceof DoubleArrayList ? subject : THROW_CCE(), l, r);
  }
  r2t(subject, indexL, indexR) {
    var l = subject.m10(indexL);
    var r = subject.m10(indexR);
    subject.m2t(indexR, l);
    subject.m2t(indexL, r);
  }
  s2t(subject, indexL, indexR) {
    return this.r2t(subject instanceof DoubleArrayList ? subject : THROW_CCE(), indexL, indexR);
  }
}
class TGenDeque$iterator$1 {
  constructor($that, this$0) {
    this.z2t_1 = $that;
    this.a2u_1 = this$0;
    this.y2t_1 = 0;
  }
  c1() {
    var _unary__edvuaz = this.y2t_1;
    this.y2t_1 = _unary__edvuaz + 1 | 0;
    return this.z2t_1.d1(_unary__edvuaz);
  }
  b1() {
    return this.y2t_1 < this.a2u_1.e1();
  }
  x6() {
    this.y2t_1 = this.y2t_1 - 1 | 0;
    this.a2u_1.r3(this.y2t_1);
  }
}
class TGenDeque {
  static b2u(initialCapacity) {
    var $this = createThis(this);
    $this.u2t_1 = 0;
    $this.v2t_1 = 0;
    var tmp = $this;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_0 = fillArrayVal(Array(initialCapacity), null);
    tmp.w2t_1 = isArray(tmp_0) ? tmp_0 : THROW_CCE();
    return $this;
  }
  static c2u() {
    return this.b2u(16);
  }
  e1() {
    return this.v2t_1;
  }
  g1() {
    return this.e1() === 0;
  }
  d2u(item) {
    resizeIfRequiredFor(this, 1);
    _addLast(this, item);
  }
  e2u(list) {
    // Inline function 'korlibs.datastructure.TGenDeque._addAll' call
    var count = list.e1();
    resizeIfRequiredFor(this, count);
    var base = this.u2t_1 + this.v2t_1 | 0;
    var inductionVariable = 0;
    if (inductionVariable < count)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp = this.w2t_1;
        var tmp_0 = (base + n | 0) % _get_capacity__a9k9f3(this) | 0;
        // Inline function 'korlibs.datastructure.TGenDeque.addAll.<anonymous>' call
        tmp[tmp_0] = list.d1(n);
      }
       while (inductionVariable < count);
    this.v2t_1 = this.v2t_1 + count | 0;
    return true;
  }
  f2u(elements) {
    return this.e2u(toList(elements));
  }
  f1(elements) {
    return this.f2u(elements);
  }
  bl() {
    if (this.v2t_1 <= 0)
      throw IndexOutOfBoundsException.pe();
    var out = this.g2u();
    nullify(this, this.u2t_1);
    this.u2t_1 = (this.u2t_1 + 1 | 0) % _get_capacity__a9k9f3(this) | 0;
    this.v2t_1 = this.v2t_1 - 1 | 0;
    return out;
  }
  dl() {
    if (this.v2t_1 <= 0)
      throw IndexOutOfBoundsException.pe();
    var out = this.h2u();
    nullify(this, internalIndex(this, this.e1() - 1 | 0));
    this.v2t_1 = this.v2t_1 - 1 | 0;
    return out;
  }
  r3(index) {
    if (index < 0 || index >= this.e1())
      throw IndexOutOfBoundsException.pe();
    if (index === 0)
      return this.bl();
    if (index === (this.e1() - 1 | 0))
      return this.dl();
    var old = this.d1(index);
    if (index < (this.e1() / 2 | 0)) {
      var inductionVariable = index;
      if (1 <= inductionVariable)
        do {
          var n = inductionVariable;
          inductionVariable = inductionVariable + -1 | 0;
          this.i2u(n, this.d1(n - 1 | 0));
        }
         while (1 <= inductionVariable);
      this.u2t_1 = umod(this.u2t_1 + 1 | 0, _get_capacity__a9k9f3(this));
    } else {
      var inductionVariable_0 = index;
      var last = this.e1() - 1 | 0;
      if (inductionVariable_0 < last)
        do {
          var n_0 = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          this.i2u(n_0, this.d1(n_0 + 1 | 0));
        }
         while (inductionVariable_0 < last);
    }
    this.v2t_1 = this.v2t_1 - 1 | 0;
    return old;
  }
  j2u(element) {
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.datastructure.TGenDeque.add.<anonymous>' call
    this.d2u(element);
    return true;
  }
  h(element) {
    return this.j2u((element == null ? true : !(element == null)) ? element : THROW_CCE());
  }
  k2u(element) {
    var index = this.l2u(element);
    if (index >= 0) {
      this.r3(index);
    }
    return index >= 0;
  }
  o3(element) {
    if (!(element == null ? true : !(element == null)))
      return false;
    return this.k2u((element == null ? true : !(element == null)) ? element : THROW_CCE());
  }
  g2u() {
    return this.w2t_1[this.u2t_1];
  }
  h2u() {
    return this.w2t_1[internalIndex(this, this.e1() - 1 | 0)];
  }
  i2u(index, value) {
    this.w2t_1[internalIndex(this, index)] = value;
  }
  d1(index) {
    return this.w2t_1[internalIndex(this, index)];
  }
  l2u(element) {
    var inductionVariable = 0;
    var last = this.e1();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (equals(this.d1(n), element))
          return n;
      }
       while (inductionVariable < last);
    return -1;
  }
  m2u(elements) {
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(collectionSizeOrDefault(elements, 10));
    var tmp0_iterator = elements.a1();
    while (tmp0_iterator.b1()) {
      var item = tmp0_iterator.c1();
      // Inline function 'korlibs.datastructure.TGenDeque.containsAll.<anonymous>' call
      var tmp$ret$0 = to(item, 0);
      destination.h(tmp$ret$0);
    }
    var emap = toLinkedMap(destination);
    var inductionVariable = 0;
    var last = this.e1();
    if (inductionVariable < last)
      do {
        var it = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var e = this.d1(it);
        // Inline function 'kotlin.collections.contains' call
        // Inline function 'kotlin.collections.containsKey' call
        if ((isInterface(emap, KtMap) ? emap : THROW_CCE()).f3(e)) {
          // Inline function 'kotlin.collections.set' call
          emap.j3(e, 1);
        }
      }
       while (inductionVariable < last);
    var tmp$ret$5;
    $l$block_0: {
      // Inline function 'kotlin.collections.all' call
      var this_0 = emap.n3();
      var tmp;
      if (isInterface(this_0, Collection)) {
        tmp = this_0.g1();
      } else {
        tmp = false;
      }
      if (tmp) {
        tmp$ret$5 = true;
        break $l$block_0;
      }
      var tmp0_iterator_0 = this_0.a1();
      while (tmp0_iterator_0.b1()) {
        var element = tmp0_iterator_0.c1();
        // Inline function 'korlibs.datastructure.TGenDeque.containsAll.<anonymous>' call
        if (!(element === 1)) {
          tmp$ret$5 = false;
          break $l$block_0;
        }
      }
      tmp$ret$5 = true;
    }
    return tmp$ret$5;
  }
  a3(elements) {
    return this.m2u(elements);
  }
  a1() {
    var that = this;
    return new TGenDeque$iterator$1(that, this);
  }
  hashCode() {
    // Inline function 'korlibs.datastructure.internal.contentHashCode' call
    var size = this.e1();
    var result = 1;
    var inductionVariable = 0;
    if (inductionVariable < size)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp = imul(31, result);
        // Inline function 'kotlin.hashCode' call
        // Inline function 'korlibs.datastructure.TGenDeque.hashCode.<anonymous>' call
        var tmp0_safe_receiver = this.d1(n);
        var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : hashCode(tmp0_safe_receiver);
        result = tmp + (tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs) | 0;
      }
       while (inductionVariable < size);
    return result;
  }
  equals(other) {
    if (!(other instanceof TGenDeque))
      return false;
    if (!(other.e1() === this.e1()))
      return false;
    var inductionVariable = 0;
    var last = this.e1();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (!equals(this.d1(n), other.d1(n)))
          return false;
      }
       while (inductionVariable < last);
    return true;
  }
  toString() {
    var sb = StringBuilder.f();
    sb.fc(_Char___init__impl__6a9atx(91));
    var inductionVariable = 0;
    var last = this.e1();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        sb.dc(this.d1(n));
        if (!(n === (this.e1() - 1 | 0))) {
          sb.ec(', ');
        }
      }
       while (inductionVariable < last);
    sb.fc(_Char___init__impl__6a9atx(93));
    return sb.toString();
  }
}
class IntDeque$iterator$1 {
  constructor($that, this$0) {
    this.r2u_1 = $that;
    this.s2u_1 = this$0;
    this.q2u_1 = 0;
  }
  c1() {
    var _unary__edvuaz = this.q2u_1;
    this.q2u_1 = _unary__edvuaz + 1 | 0;
    return this.r2u_1.d1(_unary__edvuaz);
  }
  b1() {
    return this.q2u_1 < this.s2u_1.e1();
  }
  x6() {
    this.q2u_1 = this.q2u_1 - 1 | 0;
    this.s2u_1.r3(this.q2u_1);
  }
}
class IntDeque {
  static t2u(initialCapacity) {
    var $this = createThis(this);
    $this.n2u_1 = 0;
    $this.o2u_1 = 0;
    var tmp = $this;
    var tmp_0 = new Int32Array(initialCapacity);
    tmp.p2u_1 = isIntArray(tmp_0) ? tmp_0 : THROW_CCE();
    return $this;
  }
  static u2u() {
    return this.t2u(16);
  }
  e1() {
    return this.o2u_1;
  }
  g1() {
    return this.e1() === 0;
  }
  v2u(item) {
    resizeIfRequiredFor_0(this, 1);
    _addLast_0(this, item);
  }
  w2u(list) {
    // Inline function 'korlibs.datastructure.IntDeque._addAll' call
    var count = list.e1();
    resizeIfRequiredFor_0(this, count);
    var base = this.n2u_1 + this.o2u_1 | 0;
    var inductionVariable = 0;
    if (inductionVariable < count)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp = this.p2u_1;
        var tmp_0 = (base + n | 0) % _get_capacity__a9k9f3_0(this) | 0;
        // Inline function 'korlibs.datastructure.IntDeque.addAll.<anonymous>' call
        tmp[tmp_0] = list.d1(n);
      }
       while (inductionVariable < count);
    this.o2u_1 = this.o2u_1 + count | 0;
    return true;
  }
  x2u(elements) {
    return this.w2u(toList(elements));
  }
  f1(elements) {
    return this.x2u(elements);
  }
  bl() {
    if (this.o2u_1 <= 0)
      throw IndexOutOfBoundsException.pe();
    var out = this.g2u();
    nullify_0(this, this.n2u_1);
    this.n2u_1 = (this.n2u_1 + 1 | 0) % _get_capacity__a9k9f3_0(this) | 0;
    this.o2u_1 = this.o2u_1 - 1 | 0;
    return out;
  }
  dl() {
    if (this.o2u_1 <= 0)
      throw IndexOutOfBoundsException.pe();
    var out = this.h2u();
    nullify_0(this, internalIndex_0(this, this.e1() - 1 | 0));
    this.o2u_1 = this.o2u_1 - 1 | 0;
    return out;
  }
  r3(index) {
    if (index < 0 || index >= this.e1())
      throw IndexOutOfBoundsException.pe();
    if (index === 0)
      return this.bl();
    if (index === (this.e1() - 1 | 0))
      return this.dl();
    var old = this.d1(index);
    if (index < (this.e1() / 2 | 0)) {
      var inductionVariable = index;
      if (1 <= inductionVariable)
        do {
          var n = inductionVariable;
          inductionVariable = inductionVariable + -1 | 0;
          this.r2s(n, this.d1(n - 1 | 0));
        }
         while (1 <= inductionVariable);
      this.n2u_1 = umod(this.n2u_1 + 1 | 0, _get_capacity__a9k9f3_0(this));
    } else {
      var inductionVariable_0 = index;
      var last = this.e1() - 1 | 0;
      if (inductionVariable_0 < last)
        do {
          var n_0 = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          this.r2s(n_0, this.d1(n_0 + 1 | 0));
        }
         while (inductionVariable_0 < last);
    }
    this.o2u_1 = this.o2u_1 - 1 | 0;
    return old;
  }
  y2u(element) {
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.datastructure.IntDeque.add.<anonymous>' call
    this.v2u(element);
    return true;
  }
  h(element) {
    return this.y2u((!(element == null) ? typeof element === 'number' : false) ? element : THROW_CCE());
  }
  z2u(element) {
    var index = this.a2v(element);
    if (index >= 0) {
      this.r3(index);
    }
    return index >= 0;
  }
  o3(element) {
    if (!(!(element == null) ? typeof element === 'number' : false))
      return false;
    return this.z2u((!(element == null) ? typeof element === 'number' : false) ? element : THROW_CCE());
  }
  g2u() {
    return this.p2u_1[this.n2u_1];
  }
  h2u() {
    return this.p2u_1[internalIndex_0(this, this.e1() - 1 | 0)];
  }
  r2s(index, value) {
    this.p2u_1[internalIndex_0(this, index)] = value;
  }
  d1(index) {
    return this.p2u_1[internalIndex_0(this, index)];
  }
  a2v(element) {
    var inductionVariable = 0;
    var last = this.e1();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (this.d1(n) === element)
          return n;
      }
       while (inductionVariable < last);
    return -1;
  }
  s2s(elements) {
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(collectionSizeOrDefault(elements, 10));
    var tmp0_iterator = elements.a1();
    while (tmp0_iterator.b1()) {
      var item = tmp0_iterator.c1();
      // Inline function 'korlibs.datastructure.IntDeque.containsAll.<anonymous>' call
      var tmp$ret$0 = to(item, 0);
      destination.h(tmp$ret$0);
    }
    var emap = toLinkedMap(destination);
    var inductionVariable = 0;
    var last = this.e1();
    if (inductionVariable < last)
      do {
        var it = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var e = this.d1(it);
        // Inline function 'kotlin.collections.contains' call
        // Inline function 'kotlin.collections.containsKey' call
        if ((isInterface(emap, KtMap) ? emap : THROW_CCE()).f3(e)) {
          // Inline function 'kotlin.collections.set' call
          emap.j3(e, 1);
        }
      }
       while (inductionVariable < last);
    var tmp$ret$5;
    $l$block_0: {
      // Inline function 'kotlin.collections.all' call
      var this_0 = emap.n3();
      var tmp;
      if (isInterface(this_0, Collection)) {
        tmp = this_0.g1();
      } else {
        tmp = false;
      }
      if (tmp) {
        tmp$ret$5 = true;
        break $l$block_0;
      }
      var tmp0_iterator_0 = this_0.a1();
      while (tmp0_iterator_0.b1()) {
        var element = tmp0_iterator_0.c1();
        // Inline function 'korlibs.datastructure.IntDeque.containsAll.<anonymous>' call
        if (!(element === 1)) {
          tmp$ret$5 = false;
          break $l$block_0;
        }
      }
      tmp$ret$5 = true;
    }
    return tmp$ret$5;
  }
  a3(elements) {
    return this.s2s(elements);
  }
  a1() {
    var that = this;
    return new IntDeque$iterator$1(that, this);
  }
  hashCode() {
    // Inline function 'korlibs.datastructure.internal.contentHashCode' call
    var size = this.e1();
    var result = 1;
    var inductionVariable = 0;
    if (inductionVariable < size)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp = imul(31, result);
        // Inline function 'kotlin.hashCode' call
        // Inline function 'korlibs.datastructure.IntDeque.hashCode.<anonymous>' call
        var tmp0_safe_receiver = this.d1(n);
        var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : hashCode(tmp0_safe_receiver);
        result = tmp + (tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs) | 0;
      }
       while (inductionVariable < size);
    return result;
  }
  equals(other) {
    if (!(other instanceof IntDeque))
      return false;
    if (!(other.e1() === this.e1()))
      return false;
    var inductionVariable = 0;
    var last = this.e1();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (!(this.d1(n) === other.d1(n)))
          return false;
      }
       while (inductionVariable < last);
    return true;
  }
  toString() {
    var sb = StringBuilder.f();
    sb.fc(_Char___init__impl__6a9atx(91));
    var inductionVariable = 0;
    var last = this.e1();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        sb.gh(this.d1(n));
        if (!(n === (this.e1() - 1 | 0))) {
          sb.ec(', ');
        }
      }
       while (inductionVariable < last);
    sb.fc(_Char___init__impl__6a9atx(93));
    return sb.toString();
  }
}
class FastSmallSet extends AbstractMutableSet {
  static f2v() {
    var $this = this.g8();
    $this.b2v_1 = LinkedHashSet.h1();
    $this.c2v_1 = null;
    $this.d2v_1 = null;
    $this.e2v_1 = null;
    return $this;
  }
  e1() {
    return this.b2v_1.e1();
  }
  a1() {
    return this.b2v_1.a1();
  }
  g2v(element) {
    if (this.kl(element))
      return false;
    this.b2v_1.h(element);
    return true;
  }
  h(element) {
    return this.g2v((element == null ? true : !(element == null)) ? element : THROW_CCE());
  }
  h2v(element) {
    this.c2v_1 = null;
    this.d2v_1 = null;
    this.e2v_1 = null;
    this.b2v_1.o3(element);
    return true;
  }
  o3(element) {
    if (!(element == null ? true : !(element == null)))
      return false;
    return this.h2v((element == null ? true : !(element == null)) ? element : THROW_CCE());
  }
  kl(element) {
    if (element === this.c2v_1 || element === this.d2v_1 || element === this.c2v_1)
      return true;
    var result = this.b2v_1.z2(element);
    if (result) {
      this.d2v_1 = this.c2v_1;
      this.e2v_1 = this.d2v_1;
      this.c2v_1 = element;
    }
    return result;
  }
  z2(element) {
    if (!(element == null ? true : !(element == null)))
      return false;
    return this.kl((element == null ? true : !(element == null)) ? element : THROW_CCE());
  }
  m3() {
    this.b2v_1.m3();
    this.c2v_1 = null;
    this.d2v_1 = null;
    this.e2v_1 = null;
  }
}
class GenericSubList {
  constructor(base, start, end) {
    this.i2v_1 = base;
    this.j2v_1 = start;
    this.k2v_1 = end;
    var containsUpper = this.i2v_1.e1();
    var containsArg = this.j2v_1;
    if (!(0 <= containsArg ? containsArg <= containsUpper : false))
      throw IndexOutOfBoundsException.q1('' + this.j2v_1);
    var containsUpper_0 = this.i2v_1.e1();
    var containsArg_0 = this.k2v_1;
    if (!(0 <= containsArg_0 ? containsArg_0 <= containsUpper_0 : false))
      throw IndexOutOfBoundsException.q1('' + this.k2v_1);
  }
  e1() {
    return this.k2v_1 - this.j2v_1 | 0;
  }
  ll(elements) {
    var elementsSet = toMutableSet(elements);
    var inductionVariable = 0;
    var last = this.e1();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'kotlin.collections.minusAssign' call
        var element = this.d1(n);
        elementsSet.o3(element);
      }
       while (inductionVariable < last);
    return elementsSet.g1();
  }
  a3(elements) {
    return this.ll(elements);
  }
  d1(index) {
    return this.i2v_1.d1(translateIndex(index, this));
  }
  l2v(element) {
    var inductionVariable = 0;
    var last = this.e1();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (equals(this.d1(n), element))
          return n;
      }
       while (inductionVariable < last);
    return -1;
  }
  b3(element) {
    if (!(element == null ? true : !(element == null)))
      return -1;
    return this.l2v((element == null ? true : !(element == null)) ? element : THROW_CCE());
  }
  g1() {
    return this.e1() === 0;
  }
  a1() {
    return new GenericListIterator(this);
  }
  c3() {
    return new GenericListIterator(this);
  }
  d3(index) {
    return new GenericListIterator(this, index);
  }
  e3(fromIndex, toIndex) {
    return new GenericSubList(this, fromIndex, toIndex);
  }
  toString() {
    // Inline function 'kotlin.collections.map' call
    var this_0 = until(0, this.e1());
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(collectionSizeOrDefault(this_0, 10));
    var inductionVariable = this_0.d2_1;
    var last = this_0.e2_1;
    if (inductionVariable <= last)
      do {
        var item = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'korlibs.datastructure.GenericSubList.toString.<anonymous>' call
        var it = item;
        var tmp$ret$0 = this.d1(it);
        destination.h(tmp$ret$0);
      }
       while (!(item === last));
    return toString(destination);
  }
  equals(other) {
    var tmp;
    if (other instanceof GenericSubList) {
      var tmp$ret$1;
      $l$block: {
        // Inline function 'korlibs.datastructure.internal.equaler' call
        var count = this.e1();
        var inductionVariable = 0;
        if (inductionVariable < count)
          do {
            var n = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            // Inline function 'korlibs.datastructure.GenericSubList.equals.<anonymous>' call
            if (!equals(this.d1(n), other.d1(n))) {
              tmp$ret$1 = false;
              break $l$block;
            }
          }
           while (inductionVariable < count);
        tmp$ret$1 = true;
      }
      tmp = tmp$ret$1;
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    // Inline function 'korlibs.datastructure.internal.hashCoder' call
    var count = this.e1();
    var out = 0;
    var inductionVariable = 0;
    if (inductionVariable < count)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        out = imul(out, 7);
        var tmp = out;
        // Inline function 'korlibs.datastructure.GenericSubList.hashCode.<anonymous>' call
        // Inline function 'kotlin.hashCode' call
        var tmp0_safe_receiver = this.d1(n);
        var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : hashCode(tmp0_safe_receiver);
        out = tmp + (tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs) | 0;
      }
       while (inductionVariable < count);
    return out;
  }
}
class GenericListIterator {
  constructor(list, iindex) {
    iindex = iindex === VOID ? 0 : iindex;
    this.m2v_1 = list;
    this.n2v_1 = iindex;
    var containsUpper = this.m2v_1.e1();
    var containsArg = this.n2v_1;
    if (!(0 <= containsArg ? containsArg < containsUpper : false))
      throw IndexOutOfBoundsException.q1('' + this.n2v_1);
    this.o2v_1 = this.n2v_1;
  }
  b1() {
    return this.o2v_1 < this.m2v_1.e1();
  }
  c1() {
    if (!this.b1())
      throw NoSuchElementException.b7();
    var _unary__edvuaz = this.o2v_1;
    this.o2v_1 = _unary__edvuaz + 1 | 0;
    return this.m2v_1.d1(_unary__edvuaz);
  }
  equals(other) {
    var tmp;
    var tmp_0;
    if (other instanceof GenericListIterator) {
      tmp_0 = equals(this.m2v_1, other.m2v_1);
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = this.o2v_1 === other.o2v_1;
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    return hashCode(this.m2v_1) + this.o2v_1 | 0;
  }
}
class Companion_4 {
  z2p(width, height, arraySize) {
    // Inline function 'kotlin.check' call
    // Inline function 'kotlin.contracts.contract' call
    if (!(arraySize >= imul(width, height))) {
      // Inline function 'korlibs.datastructure.Companion.checkArraySize.<anonymous>' call
      var message = 'backing array of size=' + arraySize + ', has less elements than ' + width + ' * ' + height;
      throw IllegalStateException.l5(toString(message));
    }
  }
}
class Companion_5 {
  constructor() {
    this.f2w_1 = 2147483646;
    this.g2w_1 = 2147483647;
    this.h2w_1 = 0;
  }
}
class Entry {
  constructor(key, value) {
    this.l2w_1 = key;
    this.m2w_1 = value;
  }
  toString() {
    return 'Entry(key=' + this.l2w_1 + ', value=' + toString_0(this.m2w_1) + ')';
  }
  hashCode() {
    var result = this.l2w_1;
    result = imul(result, 31) + (this.m2w_1 == null ? 0 : hashCode(this.m2w_1)) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Entry))
      return false;
    var tmp0_other_with_cast = other instanceof Entry ? other : THROW_CCE();
    if (!(this.l2w_1 === tmp0_other_with_cast.l2w_1))
      return false;
    if (!equals(this.m2w_1, tmp0_other_with_cast.m2w_1))
      return false;
    return true;
  }
}
class Iterator {
  constructor(map) {
    this.p2v_1 = map;
    this.q2v_1 = this.p2v_1.v2v_1 ? 2147483647 : nextNonEmptyIndex(this, this.p2v_1.z2v_1, 0);
    this.r2v_1 = new Entry(0, null);
  }
  b1() {
    return !(this.q2v_1 === 2147483646);
  }
  d2w() {
    // Inline function 'kotlin.apply' call
    var this_0 = currentKey(this);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.datastructure.Iterator.nextKey.<anonymous>' call
    next(this);
    return this_0;
  }
  e2w() {
    // Inline function 'kotlin.apply' call
    var this_0 = currentValue(this);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.datastructure.Iterator.nextValue.<anonymous>' call
    next(this);
    return this_0;
  }
}
class _no_name_provided__qut3iv {
  constructor(this$0) {
    this.n2w_1 = this$0;
  }
  a1() {
    // Inline function 'korlibs.datastructure.IntMap.<get-keys>.<anonymous>' call
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.datastructure.IntMap.<get-keys>.<anonymous>.<anonymous>' call
    var it = new Iterator(this.n2w_1);
    var tmp = IntMap$_get_keys_$o$iterator$lambda_bn8atq(it);
    return Iterator_0(tmp, IntMap$_get_keys_$o$iterator$lambda_bn8atq_0(it));
  }
}
class _no_name_provided__qut3iv_0 {
  constructor(this$0) {
    this.o2w_1 = this$0;
  }
  a1() {
    // Inline function 'korlibs.datastructure.IntMap.<get-values>.<anonymous>' call
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.datastructure.IntMap.<get-values>.<anonymous>.<anonymous>' call
    var it = new Iterator(this.o2w_1);
    var tmp = IntMap$_get_values_$o$iterator$lambda_ggo058(it);
    return Iterator_0(tmp, IntMap$_get_values_$o$iterator$lambda_ggo058_0(it));
  }
}
class IntMap {
  static i2w(nbits, loadFactor, dummy) {
    dummy = dummy === VOID ? false : dummy;
    var $this = createThis(this);
    $this.s2v_1 = nbits;
    $this.t2v_1 = loadFactor;
    $this.u2v_1 = 1 << $this.s2v_1;
    $this.v2v_1 = false;
    $this.w2v_1 = null;
    $this.x2v_1 = $this.u2v_1 - 1 | 0;
    $this.y2v_1 = 1 + imul($this.s2v_1, $this.s2v_1) | 0;
    $this.z2v_1 = new Int32Array($this.k2w());
    var tmp = $this;
    // Inline function 'kotlin.arrayOfNulls' call
    var size = $this.k2w();
    var tmp_0 = fillArrayVal(Array(size), null);
    tmp.a2w_1 = isArray(tmp_0) ? tmp_0 : THROW_CCE();
    $this.b2w_1 = numberToInt($this.u2v_1 * $this.t2v_1);
    $this.c2w_1 = 0;
    return $this;
  }
  static p2w(initialCapacity, loadFactor) {
    initialCapacity = initialCapacity === VOID ? 16 : initialCapacity;
    loadFactor = loadFactor === VOID ? 0.75 : loadFactor;
    // Inline function 'kotlin.math.max' call
    var b = ilog2Ceil(initialCapacity);
    var tmp$ret$0 = Math.max(4, b);
    return this.i2w(tmp$ret$0, loadFactor, true);
  }
  k2w() {
    return this.u2v_1 + this.y2v_1 | 0;
  }
  d1(key) {
    var index = _getKeyIndex(this, key);
    if (index < 0)
      return null;
    if (index === 2147483647)
      return this.w2v_1;
    return this.a2w_1[index];
  }
  j2w(key, value) {
    retry: while (true) {
      var index = _getKeyIndex(this, key);
      if (index < 0) {
        if (key === 0) {
          this.v2v_1 = true;
          this.w2v_1 = value;
          this.c2w_1 = this.c2w_1 + 1 | 0;
          return null;
        }
        if (this.c2w_1 >= this.b2w_1) {
          grow(this);
        }
        var index1 = hash1(this, key);
        if (this.z2v_1[index1] === 0)
          return setEmptySlot(this, index1, key, value);
        var index2 = hash2(this, key);
        if (this.z2v_1[index2] === 0)
          return setEmptySlot(this, index2, key, value);
        var index3 = hash3(this, key);
        if (this.z2v_1[index3] === 0)
          return setEmptySlot(this, index3, key, value);
        var inductionVariable = _get_stashStart__3psegu(this);
        var last = this.z2v_1.length;
        if (inductionVariable < last)
          do {
            var n = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            if (this.z2v_1[n] === 0)
              return setEmptySlot(this, n, key, value);
          }
           while (inductionVariable < last);
        if (this.y2v_1 > 512) {
          grow(this);
        } else {
          growStash(this);
        }
        continue retry;
      } else if (index === 2147483647) {
        // Inline function 'kotlin.apply' call
        var this_0 = this.w2v_1;
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'korlibs.datastructure.IntMap.set.<anonymous>' call
        this.w2v_1 = value;
        return this_0;
      } else {
        // Inline function 'kotlin.apply' call
        var this_1 = this.a2w_1[index];
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'korlibs.datastructure.IntMap.set.<anonymous>' call
        this.a2w_1[index] = value;
        return this_1;
      }
    }
  }
  i3() {
    // Inline function 'kotlin.collections.Iterable' call
    return new _no_name_provided__qut3iv(this);
  }
  n3() {
    // Inline function 'kotlin.collections.Iterable' call
    return new _no_name_provided__qut3iv_0(this);
  }
  q2w(keys, offset) {
    var inductionVariable = offset;
    var last = keys.length;
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (!(keys[n] === 0))
          return n;
      }
       while (inductionVariable < last);
    return 2147483646;
  }
  equals(other) {
    if (!(other instanceof IntMap))
      return false;
    // Inline function 'korlibs.datastructure.IntMap.fastForEachNullable' call
    // Inline function 'korlibs.datastructure.IntMap.fastKeyForEach' call
    var index = this.v2v_1 ? 2147483647 : this.q2w(this.z2v_1, 0);
    while (!(index === 2147483646)) {
      // Inline function 'korlibs.datastructure.IntMap.fastForEachNullable.<anonymous>' call
      var it;
      switch (index) {
        case 2147483647:
        case 2147483646:
          it = 0;
          break;
        default:
          it = this.z2v_1[index];
          break;
      }
      // Inline function 'korlibs.datastructure.IntMap.equals.<anonymous>' call
      var key = it;
      var value = this.d1(it);
      if (!equals(other.d1(key), value))
        return false;
      index = this.q2w(this.z2v_1, index === 2147483647 ? 0 : index + 1 | 0);
    }
    return true;
  }
  hashCode() {
    var out = 0;
    // Inline function 'korlibs.datastructure.IntMap.fastForEachNullable' call
    // Inline function 'korlibs.datastructure.IntMap.fastKeyForEach' call
    var index = this.v2v_1 ? 2147483647 : this.q2w(this.z2v_1, 0);
    while (!(index === 2147483646)) {
      // Inline function 'korlibs.datastructure.IntMap.fastForEachNullable.<anonymous>' call
      var it;
      switch (index) {
        case 2147483647:
        case 2147483646:
          it = 0;
          break;
        default:
          it = this.z2v_1[index];
          break;
      }
      // Inline function 'korlibs.datastructure.IntMap.hashCode.<anonymous>' call
      var tmp = out;
      var tmp_0 = it;
      // Inline function 'kotlin.hashCode' call
      var tmp0_safe_receiver = this.d1(it);
      var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : hashCode(tmp0_safe_receiver);
      out = tmp + (tmp_0 + (tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs) | 0) | 0;
      index = this.q2w(this.z2v_1, index === 2147483647 ? 0 : index + 1 | 0);
    }
    return out;
  }
}
class Companion_6 {
  constructor() {
    this.r2w_1 = 2147483646;
    this.s2w_1 = 2147483647;
    this.t2w_1 = 0;
  }
}
class IntIntMap {
  static f2x(nbits, loadFactor, dummy) {
    var $this = createThis(this);
    $this.u2w_1 = nbits;
    $this.v2w_1 = loadFactor;
    $this.w2w_1 = 1 << $this.u2w_1;
    $this.x2w_1 = false;
    $this.y2w_1 = 0;
    $this.z2w_1 = $this.w2w_1 - 1 | 0;
    $this.a2x_1 = 1 + imul($this.u2w_1, $this.u2w_1) | 0;
    $this.b2x_1 = new Int32Array($this.k2w());
    $this.c2x_1 = new Int32Array($this.k2w());
    $this.d2x_1 = numberToInt($this.w2w_1 * $this.v2w_1);
    $this.e2x_1 = 0;
    return $this;
  }
  static h2x(initialCapacity, loadFactor) {
    initialCapacity = initialCapacity === VOID ? 16 : initialCapacity;
    loadFactor = loadFactor === VOID ? 0.75 : loadFactor;
    // Inline function 'kotlin.math.max' call
    var b = ilog2Ceil(initialCapacity);
    var tmp$ret$0 = Math.max(4, b);
    return this.f2x(tmp$ret$0, loadFactor, true);
  }
  toString() {
    return toString(this.i2x());
  }
  k2w() {
    return this.w2w_1 + this.a2x_1 | 0;
  }
  j2x(out) {
    // Inline function 'korlibs.datastructure.IntIntMap.fastForEach' call
    // Inline function 'korlibs.datastructure.IntIntMap.fastKeyForEach' call
    var index = this.x2w_1 ? 2147483647 : this.q2w(this.b2x_1, 0);
    while (!(index === 2147483646)) {
      // Inline function 'korlibs.datastructure.IntIntMap.fastForEach.<anonymous>' call
      var it;
      switch (index) {
        case 2147483647:
        case 2147483646:
          it = 0;
          break;
        default:
          it = this.b2x_1[index];
          break;
      }
      // Inline function 'korlibs.datastructure.IntIntMap.toMap.<anonymous>' call
      var key = it;
      // Inline function 'kotlin.collections.set' call
      var value = this.d1(it);
      out.j3(key, value);
      index = this.q2w(this.b2x_1, index === 2147483647 ? 0 : index + 1 | 0);
    }
    return out;
  }
  i2x(out, $super) {
    out = out === VOID ? linkedHashMapOf([]) : out;
    return $super === VOID ? this.j2x(out) : $super.j2x.call(this, out);
  }
  rp(key) {
    return _getKeyIndex_0(this, key) >= 0;
  }
  m3() {
    this.x2w_1 = false;
    this.y2w_1 = 0;
    fill(this.b2x_1, 0);
    fill(this.c2x_1, 0);
    this.e2x_1 = 0;
  }
  d1(key) {
    var index = _getKeyIndex_0(this, key);
    if (index < 0)
      return 0;
    if (index === 2147483647)
      return this.y2w_1;
    return this.c2x_1[index];
  }
  g2x(key, value) {
    retry: while (true) {
      var index = _getKeyIndex_0(this, key);
      if (index < 0) {
        if (key === 0) {
          this.x2w_1 = true;
          this.y2w_1 = value;
          this.e2x_1 = this.e2x_1 + 1 | 0;
          return 0;
        }
        if (this.e2x_1 >= this.d2x_1) {
          grow_0(this);
        }
        var index1 = hash1_0(this, key);
        if (this.b2x_1[index1] === 0)
          return setEmptySlot_0(this, index1, key, value);
        var index2 = hash2_0(this, key);
        if (this.b2x_1[index2] === 0)
          return setEmptySlot_0(this, index2, key, value);
        var index3 = hash3_0(this, key);
        if (this.b2x_1[index3] === 0)
          return setEmptySlot_0(this, index3, key, value);
        var inductionVariable = _get_stashStart__3psegu_0(this);
        var last = this.b2x_1.length;
        if (inductionVariable < last)
          do {
            var n = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            if (this.b2x_1[n] === 0)
              return setEmptySlot_0(this, n, key, value);
          }
           while (inductionVariable < last);
        if (this.a2x_1 > 512) {
          grow_0(this);
        } else {
          growStash_0(this);
        }
        continue retry;
      } else if (index === 2147483647) {
        // Inline function 'kotlin.apply' call
        var this_0 = this.y2w_1;
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'korlibs.datastructure.IntIntMap.set.<anonymous>' call
        this.y2w_1 = value;
        return this_0;
      } else {
        // Inline function 'kotlin.apply' call
        var this_1 = this.c2x_1[index];
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'korlibs.datastructure.IntIntMap.set.<anonymous>' call
        this.c2x_1[index] = value;
        return this_1;
      }
    }
  }
  q2w(keys, offset) {
    var inductionVariable = offset;
    var last = keys.length;
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (!(keys[n] === 0))
          return n;
      }
       while (inductionVariable < last);
    return 2147483646;
  }
  equals(other) {
    if (!(other instanceof IntIntMap))
      return false;
    // Inline function 'korlibs.datastructure.IntIntMap.fastForEach' call
    // Inline function 'korlibs.datastructure.IntIntMap.fastKeyForEach' call
    var index = this.x2w_1 ? 2147483647 : this.q2w(this.b2x_1, 0);
    while (!(index === 2147483646)) {
      // Inline function 'korlibs.datastructure.IntIntMap.fastForEach.<anonymous>' call
      var it;
      switch (index) {
        case 2147483647:
        case 2147483646:
          it = 0;
          break;
        default:
          it = this.b2x_1[index];
          break;
      }
      // Inline function 'korlibs.datastructure.IntIntMap.equals.<anonymous>' call
      var key = it;
      var value = this.d1(it);
      if (!(other.d1(key) === value))
        return false;
      index = this.q2w(this.b2x_1, index === 2147483647 ? 0 : index + 1 | 0);
    }
    return true;
  }
  hashCode() {
    var out = 0;
    // Inline function 'korlibs.datastructure.IntIntMap.fastForEach' call
    // Inline function 'korlibs.datastructure.IntIntMap.fastKeyForEach' call
    var index = this.x2w_1 ? 2147483647 : this.q2w(this.b2x_1, 0);
    while (!(index === 2147483646)) {
      // Inline function 'korlibs.datastructure.IntIntMap.fastForEach.<anonymous>' call
      var it;
      switch (index) {
        case 2147483647:
        case 2147483646:
          it = 0;
          break;
        default:
          it = this.b2x_1[index];
          break;
      }
      // Inline function 'korlibs.datastructure.IntIntMap.hashCode.<anonymous>' call
      out = out + (it + this.d1(it) | 0) | 0;
      index = this.q2w(this.b2x_1, index === 2147483647 ? 0 : index + 1 | 0);
    }
    return out;
  }
}
class Iterator$1 {
  constructor($hasNext, $next) {
    this.k2x_1 = $hasNext;
    this.l2x_1 = $next;
  }
  b1() {
    return this.k2x_1();
  }
  c1() {
    return this.l2x_1();
  }
}
class Companion_7 {}
class Pool {
  static q2x(reset, preallocate, gen) {
    var tmp;
    if (reset === VOID) {
      tmp = Pool$_init_$lambda_q3cbhr;
    } else {
      tmp = reset;
    }
    reset = tmp;
    preallocate = preallocate === VOID ? 0 : preallocate;
    var $this = createThis(this);
    $this.m2x_1 = reset;
    $this.n2x_1 = gen;
    $this.o2x_1 = _TGenStack___init__impl__yynjgt();
    $this.p2x_1 = 0;
    var inductionVariable = 0;
    if (inductionVariable < preallocate)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var _unary__edvuaz = $this.p2x_1;
        $this.p2x_1 = _unary__edvuaz + 1 | 0;
        TGenStack__push_impl_9yh33t($this.o2x_1, $this.n2x_1(_unary__edvuaz));
      }
       while (inductionVariable < preallocate);
    return $this;
  }
  static r2x(preallocate, gen) {
    preallocate = preallocate === VOID ? 0 : preallocate;
    return this.q2x(Pool$_init_$lambda_q3cbhr_0, preallocate, gen);
  }
  s2x() {
    return _TGenStack___get_size__impl__cvg66t(this.o2x_1);
  }
  t2x() {
    var tmp;
    // Inline function 'kotlin.collections.isNotEmpty' call
    if (!(new TGenStack(this.o2x_1)).g1()) {
      tmp = TGenStack__pop_impl_qisxa0(this.o2x_1);
    } else {
      var _unary__edvuaz = this.p2x_1;
      this.p2x_1 = _unary__edvuaz + 1 | 0;
      tmp = this.n2x_1(_unary__edvuaz);
    }
    return tmp;
  }
  m3() {
    TGenStack__clear_impl_pali4s(this.o2x_1);
    this.p2x_1 = 0;
  }
  u2x(element) {
    this.m2x_1(element);
    TGenStack__push_impl_9yh33t(this.o2x_1, element);
  }
  v2x(elements) {
    var _iterator__ex2g4s = elements.a1();
    while (_iterator__ex2g4s.b1()) {
      var element = _iterator__ex2g4s.c1();
      this.u2x(element);
    }
  }
  hashCode() {
    return TGenStack__hashCode_impl_l04zom(this.o2x_1);
  }
  equals(other) {
    var tmp;
    var tmp_0;
    if (other instanceof Pool) {
      tmp_0 = equals(this.o2x_1, other.o2x_1);
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = this.s2x() === other.s2x();
    } else {
      tmp = false;
    }
    return tmp;
  }
}
class ConcurrentPool extends Pool {
  static d2y(reset, preallocate, gen) {
    var tmp;
    if (reset === VOID) {
      tmp = ConcurrentPool$_init_$lambda_gqhtk8;
    } else {
      tmp = reset;
    }
    reset = tmp;
    preallocate = preallocate === VOID ? 0 : preallocate;
    var $this = this.q2x(reset, preallocate, gen);
    $this.a2y_1 = reset;
    $this.b2y_1 = gen;
    $this.c2y_1 = new NonRecursiveLock();
    return $this;
  }
  t2x() {
    // Inline function 'korlibs.concurrent.lock.NonRecursiveLock.invoke' call
    // Inline function 'kotlinx.atomicfu.locks.synchronized' call
    this.c2y_1.w1z_1;
    // Inline function 'korlibs.concurrent.lock.NonRecursiveLock.invoke.<anonymous>' call
    // Inline function 'korlibs.datastructure.ConcurrentPool.alloc.<anonymous>' call
    return super.t2x();
  }
  m3() {
    // Inline function 'korlibs.concurrent.lock.NonRecursiveLock.invoke' call
    // Inline function 'kotlinx.atomicfu.locks.synchronized' call
    this.c2y_1.w1z_1;
    // Inline function 'korlibs.concurrent.lock.NonRecursiveLock.invoke.<anonymous>' call
    super.m3();
  }
  u2x(element) {
    // Inline function 'korlibs.concurrent.lock.NonRecursiveLock.invoke' call
    // Inline function 'kotlinx.atomicfu.locks.synchronized' call
    this.c2y_1.w1z_1;
    // Inline function 'korlibs.concurrent.lock.NonRecursiveLock.invoke.<anonymous>' call
    super.u2x(element);
  }
}
class ReturnablePool {
  constructor(_reset, gen) {
    var tmp;
    if (_reset === VOID) {
      tmp = ReturnablePool$_init_$lambda_rsm60r;
    } else {
      tmp = _reset;
    }
    _reset = tmp;
    this.e2y_1 = _reset;
    this.f2y_1 = gen;
    this.g2y_1 = fastArrayListOf([]);
    var tmp_0 = this;
    var tmp_1 = ReturnablePool$list$lambda(this);
    tmp_0.h2y_1 = Pool.q2x(tmp_1, VOID, ReturnablePool$list$lambda_0(this));
    this.i2y_1 = this.h2y_1.t2x();
  }
  c1() {
    // Inline function 'kotlin.collections.plusAssign' call
    var this_0 = this.g2y_1;
    var element = this.i2y_1;
    this_0.h(element);
    this.i2y_1 = this.h2y_1.t2x();
    return this.i2y_1;
  }
  j2y() {
    // Inline function 'korlibs.datastructure.FastArrayList.fastForEach' call
    // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var array = this.g2y_1.h11_1;
    var n = 0;
    while (n < array.length) {
      // Inline function 'korlibs.datastructure.ReturnablePool.reset.<anonymous>' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'korlibs.datastructure.get' call
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      // Inline function 'kotlin.js.asDynamic' call
      // Inline function 'kotlin.js.asDynamic' call
      var it = array[_unary__edvuaz];
      this.h2y_1.u2x(it);
    }
    this.g2y_1.m3();
  }
}
class sam$kotlin_Comparator$0 {
  constructor(function_0) {
    this.k2y_1 = function_0;
  }
  hj(a, b) {
    return this.k2y_1(a, b);
  }
  compare(a, b) {
    return this.hj(a, b);
  }
  s4() {
    return this.k2y_1;
  }
  equals(other) {
    var tmp;
    if (!(other == null) ? isInterface(other, Comparator) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.s4(), other.s4());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    return hashCode(this.s4());
  }
}
class Companion_8 {
  l2y(comparator, reversed_0) {
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp = fillArrayVal(Array(16), null);
    return new TGenPriorityQueue(isArray(tmp) ? tmp : THROW_CCE(), reversed_0 ? reversed(comparator) : comparator);
  }
  m2y(reversed, comparator) {
    return Companion_instance_8.l2y(new sam$kotlin_Comparator$0(comparator), reversed);
  }
  n2y(reversed, comparator, $super) {
    reversed = reversed === VOID ? false : reversed;
    return $super === VOID ? this.m2y(reversed, comparator) : $super.m2y.call(this, reversed, comparator);
  }
}
class TGenPriorityQueue$iterator$1 {
  constructor($index, this$0) {
    this.r2y_1 = $index;
    this.s2y_1 = this$0;
  }
  b1() {
    return this.r2y_1._v < this.s2y_1.q2y_1;
  }
  c1() {
    var _unary__edvuaz = this.r2y_1._v;
    this.r2y_1._v = _unary__edvuaz + 1 | 0;
    return _get_value__a43j40(_PriorityQueueNode___init__impl__34dlfu(_unary__edvuaz), this.s2y_1);
  }
  y1d() {
    throw NotImplementedError.ee();
  }
  x6() {
    return this.y1d();
  }
}
class TGenPriorityQueue {
  constructor(data, comparator) {
    this.o2y_1 = data;
    this.p2y_1 = comparator;
    this.q2y_1 = 0;
  }
  e1() {
    return this.q2y_1;
  }
  t2y() {
    if (this.q2y_1 <= 0)
      throw IndexOutOfBoundsException.pe();
    return this.o2y_1[0];
  }
  j2u(element) {
    this.q2y_1 = this.q2y_1 + 1 | 0;
    ensure_1(this, this.q2y_1);
    var i = _PriorityQueueNode___init__impl__34dlfu(this.q2y_1 - 1 | 0);
    _set_value__lx0xdg(i, this, element);
    while (!_get_isRoot__1006zj(i, this) && gt(this, _get_value__a43j40(_get_parent__oo9xup(i, this), this), _get_value__a43j40(i, this))) {
      swap_0(this, i, _get_parent__oo9xup(i, this));
      i = _get_parent__oo9xup(i, this);
    }
    return true;
  }
  h(element) {
    return this.j2u((element == null ? true : !(element == null)) ? element : THROW_CCE());
  }
  u2y() {
    if (this.q2y_1 <= 0)
      throw IndexOutOfBoundsException.pe();
    if (this.q2y_1 === 1) {
      this.q2y_1 = this.q2y_1 - 1 | 0;
      return _get_value__a43j40(_PriorityQueueNode___init__impl__34dlfu(0), this);
    }
    var root = _get_value__a43j40(_PriorityQueueNode___init__impl__34dlfu(0), this);
    _set_value__lx0xdg(_PriorityQueueNode___init__impl__34dlfu(0), this, _get_value__a43j40(_PriorityQueueNode___init__impl__34dlfu(this.q2y_1 - 1 | 0), this));
    this.q2y_1 = this.q2y_1 - 1 | 0;
    minHeapify(this, 0);
    return root;
  }
  l2u(element) {
    var inductionVariable = 0;
    var last = this.q2y_1;
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (equals(this.o2y_1[n], element))
          return n;
      }
       while (inductionVariable < last);
    return -1;
  }
  k2u(element) {
    var index = this.l2u(element);
    if (index >= 0) {
      this.v2y(index);
    }
    return index >= 0;
  }
  o3(element) {
    if (!(element == null ? true : !(element == null)))
      return false;
    return this.k2u((element == null ? true : !(element == null)) ? element : THROW_CCE());
  }
  v2y(index) {
    var i = _PriorityQueueNode___init__impl__34dlfu(index);
    while (!(_PriorityQueueNode___get_index__impl__b6r7i5(i) === 0)) {
      swap_0(this, i, _get_parent__oo9xup(i, this));
      i = _get_parent__oo9xup(i, this);
    }
    this.u2y();
  }
  m2u(elements) {
    var thisSet = toSet(this);
    var tmp$ret$0;
    $l$block_0: {
      // Inline function 'kotlin.collections.all' call
      var tmp;
      if (isInterface(elements, Collection)) {
        tmp = elements.g1();
      } else {
        tmp = false;
      }
      if (tmp) {
        tmp$ret$0 = true;
        break $l$block_0;
      }
      var tmp0_iterator = elements.a1();
      while (tmp0_iterator.b1()) {
        var element = tmp0_iterator.c1();
        // Inline function 'korlibs.datastructure.TGenPriorityQueue.containsAll.<anonymous>' call
        if (!thisSet.z2(element)) {
          tmp$ret$0 = false;
          break $l$block_0;
        }
      }
      tmp$ret$0 = true;
    }
    return tmp$ret$0;
  }
  a3(elements) {
    return this.m2u(elements);
  }
  g1() {
    return this.q2y_1 === 0;
  }
  f2u(elements) {
    var _iterator__ex2g4s = elements.a1();
    while (_iterator__ex2g4s.b1()) {
      var e = _iterator__ex2g4s.c1();
      this.j2u(e);
    }
    // Inline function 'kotlin.collections.isNotEmpty' call
    return !elements.g1();
  }
  f1(elements) {
    return this.f2u(elements);
  }
  a1() {
    var index = {_v: 0};
    return new TGenPriorityQueue$iterator$1(index, this);
  }
  toString() {
    return toString(toList(this));
  }
  equals(other) {
    var tmp;
    var tmp_0;
    if (other instanceof TGenPriorityQueue) {
      tmp_0 = contentEquals_1(this.o2y_1, other.o2y_1);
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = equals(this.p2y_1, other.p2y_1);
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    return contentHashCode_1(this.o2y_1);
  }
}
class TGenQueue {
  constructor() {
    this.w2y_1 = TGenDeque.c2u();
  }
  e1() {
    return this.w2y_1.e1();
  }
  g1() {
    return this.e1() === 0;
  }
  x2y(v) {
    this.w2y_1.d2u(v);
  }
  y2y() {
    return this.w2y_1.bl();
  }
  m2u(elements) {
    return this.w2y_1.m2u(elements);
  }
  a3(elements) {
    return this.m2u(elements);
  }
  a1() {
    return this.w2y_1.a1();
  }
  hashCode() {
    return this.w2y_1.hashCode();
  }
  equals(other) {
    var tmp;
    if (other instanceof TGenQueue) {
      tmp = this.w2y_1.equals(other.w2y_1);
    } else {
      tmp = false;
    }
    return tmp;
  }
}
class Ref$1 {
  z2y(_set____db54di) {
    this.a2z_1 = _set____db54di;
  }
  u1() {
    var tmp = this.a2z_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('value');
    }
  }
}
class Ref$2 {
  constructor($prop) {
    this.b2z_1 = $prop;
  }
  z2y(value) {
    this.b2z_1.set(value);
  }
  u1() {
    return this.b2z_1.get();
  }
}
class ByteRingBuffer {
  constructor(bits) {
    this.l2q_1 = bits;
    this.m2q_1 = 1 << this.l2q_1;
    this.n2q_1 = this.m2q_1 - 1 | 0;
    this.o2q_1 = new Int8Array(this.m2q_1);
    this.p2q_1 = 0;
    this.q2q_1 = 0;
    this.r2q_1 = this.m2q_1;
    this.s2q_1 = 0;
  }
  v16() {
    return this.o2q_1;
  }
  w16() {
    return this.p2q_1 & this.n2q_1;
  }
  x16() {
    return this.q2q_1 & this.n2q_1;
  }
  y16(count) {
    if (count < 0 || count > this.r2q_1) {
      // Inline function 'kotlin.error' call
      var message = 'Try to write more than available';
      throw IllegalStateException.l5(toString(message));
    }
    this.q2q_1 = this.q2q_1 + count | 0;
    this.s2q_1 = this.s2q_1 + count | 0;
    this.r2q_1 = this.r2q_1 - count | 0;
  }
  z16(count) {
    if (count < 0 || count > this.s2q_1) {
      // Inline function 'kotlin.error' call
      var message = 'Try to write more than available';
      throw IllegalStateException.l5(toString(message));
    }
    this.p2q_1 = this.p2q_1 + count | 0;
    this.s2q_1 = this.s2q_1 - count | 0;
    this.r2q_1 = this.r2q_1 + count | 0;
  }
  a17() {
    // Inline function 'kotlin.math.min' call
    var a = this.s2q_1;
    var b = this.m2q_1 - (this.p2q_1 & this.n2q_1) | 0;
    return Math.min(a, b);
  }
  b17() {
    // Inline function 'kotlin.math.min' call
    var a = this.r2q_1;
    var b = this.m2q_1 - (this.q2q_1 & this.n2q_1) | 0;
    return Math.min(a, b);
  }
  z2q(consume) {
    while (consume.s2q_1 > 0) {
      // Inline function 'kotlin.math.min' call
      var a = consume.a17();
      var b = this.b17();
      var copySize = Math.min(a, b);
      Memory_instance.c2z(consume.v16(), consume.w16(), this.v16(), this.x16(), copySize);
      consume.z16(copySize);
      this.y16(copySize);
    }
  }
  n16(data, offset, size) {
    // Inline function 'kotlin.math.min' call
    var a = this.r2q_1;
    var remaining = Math.min(a, size);
    var coffset = offset;
    var totalWrite = 0;
    $l$loop: while (remaining > 0) {
      // Inline function 'kotlin.math.min' call
      var a_0 = remaining;
      var b = this.b17();
      var chunkSize = Math.min(a_0, b);
      if (chunkSize <= 0)
        break $l$loop;
      Memory_instance.c2z(data, coffset, this.o2q_1, this.x16(), chunkSize);
      this.y16(chunkSize);
      coffset = coffset + chunkSize | 0;
      remaining = remaining - chunkSize | 0;
      totalWrite = totalWrite + chunkSize | 0;
    }
    return totalWrite;
  }
  d17(size) {
    // Inline function 'kotlin.math.min' call
    var a = this.s2q_1;
    var toRead = Math.min(a, size);
    this.p2q_1 = (this.p2q_1 + toRead | 0) & this.n2q_1;
    this.r2q_1 = this.r2q_1 + toRead | 0;
    this.s2q_1 = this.s2q_1 - toRead | 0;
    return toRead;
  }
  c17(data, offset, size) {
    // Inline function 'kotlin.math.min' call
    var a = this.s2q_1;
    var toRead = Math.min(a, size);
    var readCount = 0;
    var buffer = this.o2q_1;
    var mask = this.n2q_1;
    var coffset = offset;
    var lReadPos = this.p2q_1;
    $l$loop: while (true) {
      // Inline function 'kotlin.math.min' call
      var a_0 = toRead;
      var b = this.a17();
      var toReadChunk = Math.min(a_0, b);
      if (toReadChunk <= 0)
        break $l$loop;
      Memory_instance.c2z(buffer, lReadPos & mask, data, coffset, toReadChunk);
      toRead = toRead - toReadChunk | 0;
      coffset = coffset + toReadChunk | 0;
      lReadPos = lReadPos + toReadChunk | 0;
      readCount = readCount + toReadChunk | 0;
    }
    return readCount;
  }
  m3() {
    this.p2q_1 = 0;
    this.q2q_1 = 0;
    this.s2q_1 = 0;
    this.r2q_1 = this.m2q_1;
  }
  f17(offset) {
    return this.o2q_1[(this.p2q_1 + offset | 0) & this.n2q_1];
  }
  equals(other) {
    var tmp;
    var tmp_0;
    if (other instanceof ByteRingBuffer) {
      tmp_0 = this.s2q_1 === other.s2q_1;
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      var tmp$ret$1;
      $l$block: {
        // Inline function 'korlibs.datastructure.internal.equaler' call
        var count = this.s2q_1;
        var inductionVariable = 0;
        if (inductionVariable < count)
          do {
            var n = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            // Inline function 'korlibs.datastructure.ByteRingBuffer.equals.<anonymous>' call
            if (!(this.f17(n) === other.f17(n))) {
              tmp$ret$1 = false;
              break $l$block;
            }
          }
           while (inductionVariable < count);
        tmp$ret$1 = true;
      }
      tmp = tmp$ret$1;
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    return this.p16();
  }
  p16() {
    // Inline function 'korlibs.datastructure.internal.hashCoder' call
    var count = this.s2q_1;
    var out = 0;
    var inductionVariable = 0;
    if (inductionVariable < count)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        out = imul(out, 7);
        var tmp = out;
        // Inline function 'korlibs.datastructure.ByteRingBuffer.contentHashCode.<anonymous>' call
        out = tmp + this.f17(n) | 0;
      }
       while (inductionVariable < count);
    return out;
  }
}
class RingBuffer extends ByteRingBuffer {}
class ShortRingBuffer {
  constructor(bits) {
    this.b2r_1 = bits;
    this.c2r_1 = 1 << this.b2r_1;
    this.d2r_1 = this.c2r_1 - 1 | 0;
    this.e2r_1 = new Int16Array(this.c2r_1);
    this.f2r_1 = 0;
    this.g2r_1 = 0;
    this.h2r_1 = this.c2r_1;
    this.i2r_1 = 0;
    this.j2r_1 = new Int16Array(1);
  }
  q2r(data, offset, size) {
    // Inline function 'kotlin.math.min' call
    var a = this.h2r_1;
    var toWrite = Math.min(a, size);
    var inductionVariable = 0;
    if (inductionVariable < toWrite)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        this.e2r_1[this.g2r_1] = data[offset + n | 0];
        this.g2r_1 = (this.g2r_1 + 1 | 0) & this.d2r_1;
      }
       while (inductionVariable < toWrite);
    this.i2r_1 = this.i2r_1 + toWrite | 0;
    this.h2r_1 = this.h2r_1 - toWrite | 0;
    return toWrite;
  }
  p2r(data, offset, size) {
    // Inline function 'kotlin.math.min' call
    var a = this.i2r_1;
    var toRead = Math.min(a, size);
    var inductionVariable = 0;
    if (inductionVariable < toRead)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        data[offset + n | 0] = this.e2r_1[this.f2r_1];
        this.f2r_1 = (this.f2r_1 + 1 | 0) & this.d2r_1;
      }
       while (inductionVariable < toRead);
    this.h2r_1 = this.h2r_1 + toRead | 0;
    this.i2r_1 = this.i2r_1 - toRead | 0;
    return toRead;
  }
  m3() {
    this.f2r_1 = 0;
    this.g2r_1 = 0;
    this.i2r_1 = 0;
    this.h2r_1 = this.c2r_1;
  }
  f17(offset) {
    return this.e2r_1[(this.f2r_1 + offset | 0) & this.d2r_1];
  }
  equals(other) {
    var tmp;
    var tmp_0;
    if (other instanceof ShortRingBuffer) {
      tmp_0 = this.i2r_1 === other.i2r_1;
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      var tmp$ret$1;
      $l$block: {
        // Inline function 'korlibs.datastructure.internal.equaler' call
        var count = this.i2r_1;
        var inductionVariable = 0;
        if (inductionVariable < count)
          do {
            var n = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            // Inline function 'korlibs.datastructure.ShortRingBuffer.equals.<anonymous>' call
            if (!(this.f17(n) === other.f17(n))) {
              tmp$ret$1 = false;
              break $l$block;
            }
          }
           while (inductionVariable < count);
        tmp$ret$1 = true;
      }
      tmp = tmp$ret$1;
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    return this.p16();
  }
  p16() {
    // Inline function 'korlibs.datastructure.internal.hashCoder' call
    var count = this.i2r_1;
    var out = 0;
    var inductionVariable = 0;
    if (inductionVariable < count)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        out = imul(out, 7);
        var tmp = out;
        // Inline function 'korlibs.datastructure.ShortRingBuffer.contentHashCode.<anonymous>' call
        out = tmp + this.f17(n) | 0;
      }
       while (inductionVariable < count);
    return out;
  }
}
class Companion_9 {}
class TGenStack {
  constructor(items) {
    this.d2z_1 = items;
  }
  e1() {
    return _TGenStack___get_size__impl__cvg66t(this.d2z_1);
  }
  g1() {
    return TGenStack__isEmpty_impl_bsbpyi(this.d2z_1);
  }
  m2u(elements) {
    return TGenStack__containsAll_impl_ic9i7r(this.d2z_1, elements);
  }
  a3(elements) {
    return TGenStack__containsAll_impl_ic9i7r_0(this, elements);
  }
  a1() {
    return TGenStack__iterator_impl_2pdia5(this.d2z_1);
  }
  toString() {
    return TGenStack__toString_impl_s9t5hn(this.d2z_1);
  }
  hashCode() {
    return TGenStack__hashCode_impl_l04zom(this.d2z_1);
  }
  equals(other) {
    return TGenStack__equals_impl_w9i35u(this.d2z_1, other);
  }
}
class SyncPauseable {
  constructor() {
    this.e2z_1 = new Lock();
    this.f2z_1 = false;
  }
  g2z(value) {
    if (!(this.f2z_1 === value)) {
      this.f2z_1 = value;
      // Inline function 'korlibs.concurrent.lock.Lock.invoke' call
      var this_0 = this.e2z_1;
      $l$block: {
        // Inline function 'korlibs.concurrent.lock.LockImpl.lockUnlock' call
        this_0.b20();
        try {
          this.e2z_1.f20();
          break $l$block;
        }finally {
          this_0.d20();
        }
      }
    }
  }
}
class Memory {
  x2t(src, srcPos, dst, dstPos, size) {
    // Inline function 'kotlin.collections.copyInto' call
    var destination = isArray(dst) ? dst : THROW_CCE();
    var endIndex = srcPos + size | 0;
    arrayCopy(src, destination, dstPos, srcPos, endIndex);
  }
  c2z(src, srcPos, dst, dstPos, size) {
    // Inline function 'kotlin.collections.copyInto' call
    var endIndex = srcPos + size | 0;
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp = src;
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    arrayCopy(tmp, dst, dstPos, srcPos, endIndex);
  }
  q2s(src, srcPos, dst, dstPos, size) {
    // Inline function 'kotlin.collections.copyInto' call
    var endIndex = srcPos + size | 0;
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp = src;
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    arrayCopy(tmp, dst, dstPos, srcPos, endIndex);
  }
  a2s(src, srcPos, dst, dstPos, size) {
    // Inline function 'kotlin.collections.copyInto' call
    var endIndex = srcPos + size | 0;
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp = src;
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    arrayCopy(tmp, dst, dstPos, srcPos, endIndex);
  }
  l2t(src, srcPos, dst, dstPos, size) {
    // Inline function 'kotlin.collections.copyInto' call
    var endIndex = srcPos + size | 0;
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp = src;
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    arrayCopy(tmp, dst, dstPos, srcPos, endIndex);
  }
}
class PointList {}
function get_dimensions() {
  return 2;
}
function isEmpty() {
  return this.e1() === 0;
}
function getX(index) {
  return this.s2f(index, 0);
}
function getY(index) {
  return this.s2f(index, 1);
}
function get_1(index) {
  return Vector2D.q2f(this.s2f(index, 0), this.s2f(index, 1));
}
function getComponentList(component, out) {
  var inductionVariable = 0;
  var last = this.e1();
  if (inductionVariable < last)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      out[n] = this.s2f(n, component);
    }
     while (inductionVariable < last);
  return out;
}
function getComponentList$default(component, out, $super) {
  out = out === VOID ? new Float64Array(this.e1()) : out;
  return $super === VOID ? this.h2z(component, out) : getComponentList(component, out);
}
function get_first() {
  return this.d1(0);
}
function get_last() {
  return this.d1(this.e1() - 1 | 0);
}
function clone(out) {
  out.n2z(this);
  return out;
}
function clone$default(out, $super) {
  out = out === VOID ? new PointArrayList(this.e1()) : out;
  return $super === VOID ? this.j2z(out) : clone(out);
}
class Companion_10 {}
class PointArrayList {
  constructor(capacity) {
    capacity = capacity === VOID ? 7 : capacity;
    this.k2z_1 = new Mixin();
    this.l2z_1 = false;
    this.m2z_1 = DoubleArrayList.a2t(imul(capacity, 2));
  }
  r10(_set____db54di) {
    this.k2z_1.r10(_set____db54di);
  }
  s10() {
    return this.k2z_1.s10();
  }
  e1() {
    return this.m2z_1.e1() / 2 | 0;
  }
  s2f(index_0, dim) {
    return this.m2z_1.m10(index(this, index_0, dim));
  }
  n2f(index_0) {
    return this.m2z_1.m10(index(this, index_0, 0));
  }
  o2f(index_0) {
    return this.m2z_1.m10(index(this, index_0, 1));
  }
  d1(index_0) {
    var i = index(this, index_0, 0);
    return Vector2D.q2f(this.m2z_1.m10(i), this.m2z_1.m10(i + 1 | 0));
  }
  oh() {
    this.m2z_1.m3();
    return this;
  }
  p2z(x, y) {
    this.m2z_1.f2t(x, y);
    return this;
  }
  q2z(p) {
    return this.p2z(p.h2d_1, p.i2d_1);
  }
  r2z(p) {
    return this.s2z(p);
  }
  s2z(p) {
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.math.geom.PointArrayList.addAll.<anonymous>' call
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var n = 0;
    while (n < p.e1()) {
      // Inline function 'korlibs.math.geom.PointArrayList.addAll.<anonymous>.<anonymous>' call
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      var destruct = p.d1(_unary__edvuaz);
      var x = destruct.ul();
      var y = destruct.vl();
      this.p2z(x, y);
    }
    return this;
  }
  t2z(p, index) {
    this.p2z(p.n2f(index), p.o2f(index));
  }
  n2z(other) {
    this.oh();
    this.r2z(other);
    return this;
  }
  j2z(out) {
    return out.oh().r2z(this);
  }
  w2s(index_0, count) {
    this.m2z_1.w2s(index(this, index_0, 0), imul(count, 2));
    return this;
  }
  u2z(index, count, $super) {
    count = count === VOID ? 1 : count;
    return $super === VOID ? this.w2s(index, count) : $super.w2s.call(this, index, count);
  }
  equals(other) {
    var tmp;
    if (other instanceof PointArrayList) {
      tmp = this.m2z_1.equals(other.m2z_1);
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    return this.m2z_1.hashCode();
  }
  toString() {
    var sb = StringBuilder.f();
    sb.fc(_Char___init__impl__6a9atx(91));
    var inductionVariable = 0;
    var last = this.e1();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var _destruct__k2r9zo = this.d1(n);
        var x = _destruct__k2r9zo.ul();
        var y = _destruct__k2r9zo.vl();
        if (!(n === 0)) {
          sb.ec(', ');
        }
        sb.fc(_Char___init__impl__6a9atx(40));
        if (x === round(x))
          sb.gh(numberToInt(x));
        else
          sb.jh(x);
        sb.ec(', ');
        if (y === round(y))
          sb.gh(numberToInt(y));
        else
          sb.jh(y);
        sb.fc(_Char___init__impl__6a9atx(41));
      }
       while (inductionVariable < last);
    sb.fc(_Char___init__impl__6a9atx(93));
    return sb.toString();
  }
  wz(other, epsilon) {
    return this.t2f((!(other == null) ? isInterface(other, IDoubleVectorList) : false) ? other : THROW_CCE(), epsilon);
  }
  a3(elements) {
    return this.l2f(elements);
  }
  b3(element) {
    if (!(element instanceof Vector2D))
      return -1;
    return this.j2f(element instanceof Vector2D ? element : THROW_CCE());
  }
}
class DoubleVectorArrayList {
  constructor(dimensions, capacity) {
    capacity = capacity === VOID ? 7 : capacity;
    this.v2z_1 = new Mixin();
    this.w2z_1 = dimensions;
    this.x2z_1 = DoubleArrayList.a2t(imul(capacity, this.w2z_1));
    this.y2z_1 = false;
  }
  r10(_set____db54di) {
    this.v2z_1.r10(_set____db54di);
  }
  s10() {
    return this.v2z_1.s10();
  }
  u2f() {
    return this.w2z_1;
  }
  e1() {
    return this.x2z_1.e1() / this.w2z_1 | 0;
  }
  s2f(index, dim) {
    return this.x2z_1.d1(imul(index, this.w2z_1) + dim | 0);
  }
  f2t(v0, v1) {
    // Inline function 'kotlin.also' call
    checkDimensions(this, 2);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.math.geom.DoubleVectorArrayList.add.<anonymous>' call
    this.x2z_1.f2t(v0, v1);
    return Unit_instance;
  }
  g2t(v0, v1, v2, v3) {
    // Inline function 'kotlin.also' call
    checkDimensions(this, 4);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.math.geom.DoubleVectorArrayList.add.<anonymous>' call
    this.x2z_1.g2t(v0, v1, v2, v3);
    return Unit_instance;
  }
  h2t(v0, v1, v2, v3, v4, v5) {
    // Inline function 'kotlin.also' call
    checkDimensions(this, 6);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.math.geom.DoubleVectorArrayList.add.<anonymous>' call
    this.x2z_1.h2t(v0, v1, v2, v3, v4, v5);
    return Unit_instance;
  }
  z2z(index, out, roundDecimalPlaces) {
    appendGenericArray(out, this.w2z_1, DoubleVectorArrayList$vectorToStringBuilder$lambda(this, index, roundDecimalPlaces));
  }
  equals(other) {
    var tmp;
    var tmp_0;
    if (other instanceof DoubleVectorArrayList) {
      tmp_0 = this.w2z_1 === other.w2z_1;
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = this.x2z_1.equals(other.x2z_1);
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    return this.x2z_1.hashCode();
  }
  toString() {
    return this.a30(null);
  }
  a30(roundDecimalPlaces) {
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder.f();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.math.geom.DoubleVectorArrayList.toString.<anonymous>' call
    this_0.ec('VectorArrayList[' + this.e1() + '](\n');
    var inductionVariable = 0;
    var last = this.e1();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (!(n === 0)) {
          this_0.ec(', \n');
        }
        this_0.ec('   ');
        this.z2z(n, this_0, roundDecimalPlaces);
      }
       while (inductionVariable < last);
    this_0.ec('\n)');
    return this_0.toString();
  }
  m3() {
    this.x2z_1.m3();
  }
  wz(other, epsilon) {
    return this.t2f((!(other == null) ? isInterface(other, IDoubleVectorList) : false) ? other : THROW_CCE(), epsilon);
  }
}
class Companion_11 {}
class PointIntArrayList {
  constructor(capacity) {
    capacity = capacity === VOID ? 7 : capacity;
    this.b30_1 = new Mixin();
    this.c30_1 = false;
    this.d30_1 = IntArrayList.g2s(capacity);
    this.e30_1 = IntArrayList.g2s(capacity);
  }
  r10(_set____db54di) {
    this.b30_1.r10(_set____db54di);
  }
  s10() {
    return this.b30_1.s10();
  }
  e1() {
    return this.d30_1.e1();
  }
  g1() {
    return this.e1() === 0;
  }
  m3() {
    this.d30_1.m3();
    this.e30_1.m3();
  }
  f30(x, y) {
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.math.geom.PointIntArrayList.add.<anonymous>' call
    this.d30_1.n2s(x);
    this.e30_1.n2s(y);
    return this;
  }
  g30(p) {
    return this.f30(p.w2m_1, p.x2m_1);
  }
  n2f(index) {
    return this.d30_1.m10(index);
  }
  o2f(index) {
    return this.e30_1.m10(index);
  }
  toString() {
    var sb = StringBuilder.f();
    sb.fc(_Char___init__impl__6a9atx(91));
    var inductionVariable = 0;
    var last = this.e1();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var x = this.n2f(n);
        var y = this.o2f(n);
        if (!(n === 0)) {
          sb.ec(', ');
        }
        sb.fc(_Char___init__impl__6a9atx(40));
        sb.gh(x);
        sb.ec(', ');
        sb.gh(y);
        sb.fc(_Char___init__impl__6a9atx(41));
      }
       while (inductionVariable < last);
    sb.fc(_Char___init__impl__6a9atx(93));
    return sb.toString();
  }
}
//endregion
var Companion_instance;
function Companion_getInstance() {
  return Companion_instance;
}
var Companion_instance_0;
function Companion_getInstance_0() {
  return Companion_instance_0;
}
function ensureWrite($this, count) {
  if (count <= $this.v2q_1.r2q_1)
    return Unit_instance;
  if (!$this.u2q_1) {
    var message = "Can't grow ByteArrayDeque. Need to write " + count + ', but only ' + $this.v2q_1.r2q_1 + ' is available';
    println('ERROR: ' + message);
    // Inline function 'kotlin.error' call
    throw IllegalStateException.l5(toString(message));
  }
  var minNewSize = $this.v2q_1.s2q_1 + count | 0;
  var tmp = $this;
  // Inline function 'kotlin.also' call
  var this_0 = new RingBuffer(ilog2(minNewSize) + 2 | 0);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.datastructure.ByteArrayDeque.ensureWrite.<anonymous>' call
  this_0.z2q($this.v2q_1);
  tmp.v2q_1 = this_0;
}
function ensureWrite_0($this, count) {
  if (count > $this.l2r_1.h2r_1) {
    var minNewSize = $this.l2r_1.i2r_1 + count | 0;
    var newBits = ilog2(minNewSize) + 2 | 0;
    var newRing = new ShortRingBuffer(newBits);
    while ($this.l2r_1.i2r_1 > 0) {
      var read = $this.l2r_1.p2r($this.m2r_1, 0, $this.m2r_1.length);
      newRing.q2r($this.m2r_1, 0, read);
    }
    $this.l2r_1 = newRing;
  }
  return $this;
}
function swap(_this__u8e3s4, lIndex, rIndex) {
  var temp = _this__u8e3s4[lIndex];
  _this__u8e3s4[lIndex] = _this__u8e3s4[rIndex];
  _this__u8e3s4[rIndex] = temp;
}
function rotateRight(_this__u8e3s4, offset) {
  offset = offset === VOID ? 1 : offset;
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure._rotateRight' call
    var size = _this__u8e3s4.length;
    var offset_0 = umod(offset, size);
    if (offset_0 === 0) {
      tmp$ret$0 = Unit_instance;
      break $l$block;
    }
    // Inline function 'kotlin.check' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.check' call
    // Inline function 'kotlin.contracts.contract' call
    if (!(1 <= offset_0 ? offset_0 < size : false)) {
      // Inline function 'kotlin.check.<anonymous>' call
      var message = 'Check failed.';
      throw IllegalStateException.l5(toString(message));
    }
    // Inline function 'korlibs.datastructure.rotateRight.<anonymous>' call
    reverse(_this__u8e3s4, 0, size);
    // Inline function 'korlibs.datastructure.rotateRight.<anonymous>' call
    reverse(_this__u8e3s4, 0, offset_0);
    // Inline function 'korlibs.datastructure.rotateRight.<anonymous>' call
    reverse(_this__u8e3s4, offset_0, size);
  }
  return tmp$ret$0;
}
var Companion_instance_1;
function Companion_getInstance_1() {
  return Companion_instance_1;
}
function ensure($this, count) {
  if (($this.u2r_1 + count | 0) > $this.t2r_1.length) {
    var tmp = $this;
    var tmp_0 = $this.t2r_1;
    // Inline function 'kotlin.math.max' call
    var a = $this.u2r_1 + count | 0;
    var b = imul($this.t2r_1.length, 3);
    var tmp$ret$0 = Math.max(a, b);
    var tmp_1 = copyOf(tmp_0, tmp$ret$0);
    tmp.t2r_1 = isFloatArray(tmp_1) ? tmp_1 : THROW_CCE();
  }
}
var Companion_instance_2;
function Companion_getInstance_2() {
  return Companion_instance_2;
}
var Companion_instance_3;
function Companion_getInstance_3() {
  return Companion_instance_3;
}
function ensure_0($this, count) {
  if (($this.z2s_1 + count | 0) > $this.y2s_1.length) {
    var tmp = $this;
    var tmp_0 = $this.y2s_1;
    // Inline function 'kotlin.math.max' call
    var a = $this.z2s_1 + count | 0;
    var b = imul($this.y2s_1.length, 3);
    var tmp$ret$0 = Math.max(a, b);
    var tmp_1 = copyOf_1(tmp_0, tmp$ret$0);
    tmp.y2s_1 = isDoubleArray(tmp_1) ? tmp_1 : THROW_CCE();
  }
}
function intArrayListOf(values) {
  return IntArrayList.k2s(values.slice());
}
function toIntArrayList(_this__u8e3s4) {
  return IntArrayList.k2s(_this__u8e3s4.slice());
}
function floatArrayListOf(values) {
  return FloatArrayList.w2r(values.slice());
}
function doubleArrayListOf(values) {
  return DoubleArrayList.d2t(values.slice());
}
function sort(_this__u8e3s4, start, end, reversed) {
  start = start === VOID ? 0 : start;
  end = end === VOID ? _this__u8e3s4.e1() : end;
  reversed = reversed === VOID ? false : reversed;
  return genericSort_0(_this__u8e3s4, start, end - 1 | 0, DoubleArrayListSortOps_getInstance(), reversed);
}
function reverse_0(_this__u8e3s4, start, end) {
  start = start === VOID ? 0 : start;
  end = end === VOID ? _this__u8e3s4.e1() : end;
  return DoubleArrayListSortOps_getInstance().o2t(_this__u8e3s4, start, end - 1 | 0);
}
var DoubleArrayListSortOps_instance;
function DoubleArrayListSortOps_getInstance() {
  if (DoubleArrayListSortOps_instance === VOID)
    new DoubleArrayListSortOps();
  return DoubleArrayListSortOps_instance;
}
function _get__data__kyoi3c($this) {
  // Inline function 'korlibs.datastructure.fastCastTo' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return $this.w2t_1;
}
function _get_capacity__a9k9f3($this) {
  return $this.w2t_1.length;
}
function resizeIfRequiredFor($this, count) {
  if (($this.e1() + count | 0) > _get_capacity__a9k9f3($this)) {
    var i = $this.w2t_1;
    var istart = $this.u2t_1;
    // Inline function 'kotlin.arrayOfNulls' call
    // Inline function 'kotlin.comparisons.maxOf' call
    var a = $this.w2t_1.length + 7 | 0;
    // Inline function 'kotlin.comparisons.maxOf' call
    var a_0 = $this.e1() + count | 0;
    var b = imul($this.w2t_1.length, 2);
    var b_0 = Math.max(a_0, b);
    var size = Math.max(a, b_0);
    var _o = fillArrayVal(Array(size), null);
    var o = isArray(_o) ? _o : THROW_CCE();
    copyCyclic($this, i, istart, o, $this.v2t_1);
    $this.w2t_1 = o;
    $this.u2t_1 = 0;
  }
}
function copyCyclic($this, i, istart, o, count) {
  // Inline function 'kotlin.math.min' call
  var a = i.length - istart | 0;
  var size1 = Math.min(a, count);
  var size2 = count - size1 | 0;
  Memory_instance.x2t(i, istart, o, 0, size1);
  if (size2 > 0) {
    Memory_instance.x2t(i, 0, o, size1, size2);
  }
}
function _addLast($this, item) {
  $this.w2t_1[($this.u2t_1 + $this.v2t_1 | 0) % _get_capacity__a9k9f3($this) | 0] = item;
  $this.v2t_1 = $this.v2t_1 + 1 | 0;
}
function nullify($this, index) {
  _get__data__kyoi3c($this)[index] = null;
}
function internalIndex($this, index) {
  return umod($this.u2t_1 + index | 0, _get_capacity__a9k9f3($this));
}
function _get__data__kyoi3c_0($this) {
  // Inline function 'korlibs.datastructure.fastCastTo' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return $this.p2u_1;
}
function _get_capacity__a9k9f3_0($this) {
  return $this.p2u_1.length;
}
function resizeIfRequiredFor_0($this, count) {
  if (($this.e1() + count | 0) > _get_capacity__a9k9f3_0($this)) {
    var i = $this.p2u_1;
    var istart = $this.n2u_1;
    // Inline function 'kotlin.comparisons.maxOf' call
    var a = $this.p2u_1.length + 7 | 0;
    // Inline function 'kotlin.comparisons.maxOf' call
    var a_0 = $this.e1() + count | 0;
    var b = imul($this.p2u_1.length, 2);
    var b_0 = Math.max(a_0, b);
    var tmp$ret$1 = Math.max(a, b_0);
    var _o = new Int32Array(tmp$ret$1);
    var o = isIntArray(_o) ? _o : THROW_CCE();
    copyCyclic_0($this, i, istart, o, $this.o2u_1);
    $this.p2u_1 = o;
    $this.n2u_1 = 0;
  }
}
function copyCyclic_0($this, i, istart, o, count) {
  // Inline function 'kotlin.math.min' call
  var a = i.length - istart | 0;
  var size1 = Math.min(a, count);
  var size2 = count - size1 | 0;
  Memory_instance.q2s(i, istart, o, 0, size1);
  if (size2 > 0) {
    Memory_instance.q2s(i, 0, o, size1, size2);
  }
}
function _addLast_0($this, item) {
  $this.p2u_1[($this.n2u_1 + $this.o2u_1 | 0) % _get_capacity__a9k9f3_0($this) | 0] = item;
  $this.o2u_1 = $this.o2u_1 + 1 | 0;
}
function nullify_0($this, index) {
  _get__data__kyoi3c_0($this)[index] = 0;
}
function internalIndex_0($this, index) {
  return umod($this.n2u_1 + index | 0, _get_capacity__a9k9f3_0($this));
}
function getAndRemove(_this__u8e3s4, key) {
  // Inline function 'kotlin.also' call
  var this_0 = get_2(_this__u8e3s4, key);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.datastructure.getAndRemove.<anonymous>' call
  remove(_this__u8e3s4, key);
  return this_0;
}
function get_keys(_this__u8e3s4) {
  return keys(_this__u8e3s4);
}
function translateIndex(_this__u8e3s4, $this) {
  if (!(0 <= _this__u8e3s4 ? _this__u8e3s4 < $this.e1() : false))
    throw IndexOutOfBoundsException.q1('' + _this__u8e3s4);
  return $this.j2v_1 + _this__u8e3s4 | 0;
}
var Companion_instance_4;
function Companion_getInstance_4() {
  return Companion_instance_4;
}
function IArray2$asString$lambda(this$0) {
  return function (y) {
    // Inline function 'kotlin.collections.map' call
    var this_0 = until(0, this$0.x2p());
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(collectionSizeOrDefault(this_0, 10));
    var inductionVariable = this_0.d2_1;
    var last = this_0.e2_1;
    if (inductionVariable <= last)
      do {
        var item = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'korlibs.datastructure.IArray2.asString.<anonymous>.<anonymous>' call
        var x = item;
        var tmp$ret$0 = this$0.e2q(x, y);
        destination.h(tmp$ret$0);
      }
       while (!(item === last));
    return joinToString(destination, ', ');
  };
}
function indexOr(_this__u8e3s4, x, y, invalid) {
  invalid = invalid === VOID ? -1 : invalid;
  if (!(0 <= x ? x < _this__u8e3s4.x2p() : false) || !(0 <= y ? y < _this__u8e3s4.y2p() : false))
    return invalid;
  return imul(y, _this__u8e3s4.x2p()) + x | 0;
}
function currentKey($this) {
  switch ($this.q2v_1) {
    case 2147483647:
    case 2147483646:
      return 0;
    default:
      return $this.p2v_1.z2v_1[$this.q2v_1];
  }
}
function currentValue($this) {
  switch ($this.q2v_1) {
    case 2147483647:
      return $this.p2v_1.w2v_1;
    case 2147483646:
      return null;
    default:
      return $this.p2v_1.a2w_1[$this.q2v_1];
  }
}
function nextNonEmptyIndex($this, keys, offset) {
  var inductionVariable = offset;
  var last = keys.length;
  if (inductionVariable < last)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      if (!(keys[n] === 0))
        return n;
    }
     while (inductionVariable < last);
  return 2147483646;
}
function next($this) {
  if (!($this.q2v_1 === 2147483646))
    $this.q2v_1 = nextNonEmptyIndex($this, $this.p2v_1.z2v_1, $this.q2v_1 === 2147483647 ? 0 : $this.q2v_1 + 1 | 0);
}
function IntMap$_get_keys_$o$iterator$lambda_bn8atq($it) {
  return function () {
    return $it.b1();
  };
}
function IntMap$_get_keys_$o$iterator$lambda_bn8atq_0($it) {
  return function () {
    return $it.d2w();
  };
}
function IntMap$_get_values_$o$iterator$lambda_ggo058($it) {
  return function () {
    return $it.b1();
  };
}
function IntMap$_get_values_$o$iterator$lambda_ggo058_0($it) {
  return function () {
    return $it.e2w();
  };
}
var Companion_instance_5;
function Companion_getInstance_5() {
  return Companion_instance_5;
}
function _get_stashStart__3psegu($this) {
  return $this.z2v_1.length - $this.y2v_1 | 0;
}
function grow($this) {
  var inc = $this.s2v_1 < 20 ? 3 : 1;
  var newnbits = $this.s2v_1 + inc | 0;
  var new_0 = IntMap.i2w(newnbits, $this.t2v_1, true);
  var inductionVariable = 0;
  var last = $this.z2v_1.length - 1 | 0;
  if (inductionVariable <= last)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var k = $this.z2v_1[n];
      if (!(k === 0)) {
        new_0.j2w(k, $this.a2w_1[n]);
      }
    }
     while (inductionVariable <= last);
  $this.s2v_1 = new_0.s2v_1;
  $this.u2v_1 = new_0.u2v_1;
  $this.x2v_1 = new_0.x2v_1;
  $this.y2v_1 = new_0.y2v_1;
  $this.z2v_1 = new_0.z2v_1;
  $this.a2w_1 = new_0.a2w_1;
  $this.b2w_1 = new_0.b2w_1;
}
function growStash($this) {
  $this.y2v_1 = imul($this.y2v_1, 2);
  $this.z2v_1 = copyOf_0($this.z2v_1, $this.k2w());
  $this.a2w_1 = copyOf_2($this.a2w_1, $this.k2w());
}
function _getKeyIndex($this, key) {
  if (key === 0)
    return $this.v2v_1 ? 2147483647 : -1;
  var index1 = hash1($this, key);
  if ($this.z2v_1[index1] === key)
    return index1;
  var index2 = hash2($this, key);
  if ($this.z2v_1[index2] === key)
    return index2;
  var index3 = hash3($this, key);
  if ($this.z2v_1[index3] === key)
    return index3;
  var inductionVariable = _get_stashStart__3psegu($this);
  var last = $this.z2v_1.length;
  if (inductionVariable < last)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      if ($this.z2v_1[n] === key)
        return n;
    }
     while (inductionVariable < last);
  return -1;
}
function setEmptySlot($this, index, key, value) {
  if (!($this.z2v_1[index] === 0))
    throw IllegalStateException.c6();
  $this.z2v_1[index] = key;
  $this.a2w_1[index] = value;
  $this.c2w_1 = $this.c2w_1 + 1 | 0;
  return null;
}
function hash1($this, key) {
  return _hash1(key, $this.x2v_1);
}
function hash2($this, key) {
  return _hash2(key, $this.x2v_1);
}
function hash3($this, key) {
  return _hash3(key, $this.x2v_1);
}
var Companion_instance_6;
function Companion_getInstance_6() {
  return Companion_instance_6;
}
function _get_stashStart__3psegu_0($this) {
  return $this.b2x_1.length - $this.a2x_1 | 0;
}
function grow_0($this) {
  var inc = $this.u2w_1 < 20 ? 3 : 1;
  var newnbits = $this.u2w_1 + inc | 0;
  var new_0 = IntIntMap.f2x(newnbits, $this.v2w_1, true);
  var inductionVariable = 0;
  var last = $this.b2x_1.length - 1 | 0;
  if (inductionVariable <= last)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var k = $this.b2x_1[n];
      if (!(k === 0)) {
        new_0.g2x(k, $this.c2x_1[n]);
      }
    }
     while (inductionVariable <= last);
  $this.u2w_1 = new_0.u2w_1;
  $this.w2w_1 = new_0.w2w_1;
  $this.z2w_1 = new_0.z2w_1;
  $this.a2x_1 = new_0.a2x_1;
  $this.b2x_1 = new_0.b2x_1;
  $this.c2x_1 = new_0.c2x_1;
  $this.d2x_1 = new_0.d2x_1;
}
function growStash_0($this) {
  $this.a2x_1 = imul($this.a2x_1, 2);
  $this.b2x_1 = copyOf_0($this.b2x_1, $this.k2w());
  $this.c2x_1 = copyOf_0($this.c2x_1, $this.k2w());
}
function _getKeyIndex_0($this, key) {
  if (key === 0)
    return $this.x2w_1 ? 2147483647 : -1;
  var index1 = hash1_0($this, key);
  if ($this.b2x_1[index1] === key)
    return index1;
  var index2 = hash2_0($this, key);
  if ($this.b2x_1[index2] === key)
    return index2;
  var index3 = hash3_0($this, key);
  if ($this.b2x_1[index3] === key)
    return index3;
  var inductionVariable = _get_stashStart__3psegu_0($this);
  var last = $this.b2x_1.length;
  if (inductionVariable < last)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      if ($this.b2x_1[n] === key)
        return n;
    }
     while (inductionVariable < last);
  return -1;
}
function setEmptySlot_0($this, index, key, value) {
  if (!($this.b2x_1[index] === 0))
    throw IllegalStateException.c6();
  $this.b2x_1[index] = key;
  $this.c2x_1[index] = value;
  $this.e2x_1 = $this.e2x_1 + 1 | 0;
  return 0;
}
function hash1_0($this, key) {
  return _hash1(key, $this.z2w_1);
}
function hash2_0($this, key) {
  return _hash2(key, $this.z2w_1);
}
function hash3_0($this, key) {
  return _hash3(key, $this.z2w_1);
}
function toIntMap(_this__u8e3s4) {
  var out = IntMap.p2w(numberToInt(_this__u8e3s4.e1() * 1.25));
  // Inline function 'kotlin.collections.iterator' call
  var _iterator__ex2g4s = _this__u8e3s4.s1().a1();
  while (_iterator__ex2g4s.b1()) {
    var _destruct__k2r9zo = _iterator__ex2g4s.c1();
    // Inline function 'kotlin.collections.component1' call
    var k = _destruct__k2r9zo.t1();
    // Inline function 'kotlin.collections.component2' call
    var v = _destruct__k2r9zo.u1();
    out.j2w(k, v);
  }
  return out;
}
function _hash1(key, mask) {
  return _mask(key, mask);
}
function _hash2(key, mask) {
  return _mask(imul(key, 1294968109), mask);
}
function _hash3(key, mask) {
  return _mask(imul(key, 294969449), mask);
}
function _mask(value, mask) {
  return (((value + ((value >>> 8 | 0) & 255) | 0) + ((value >>> 16 | 0) & 255) | 0) + (value >> 24 & 255) | 0) & mask;
}
function associateByInt(_this__u8e3s4, block) {
  var n = 0;
  var out = IntMap.p2w();
  var _iterator__ex2g4s = _this__u8e3s4.a1();
  while (_iterator__ex2g4s.b1()) {
    var it = _iterator__ex2g4s.c1();
    var _unary__edvuaz = n;
    n = _unary__edvuaz + 1 | 0;
    out.j2w(block(_unary__edvuaz, it), it);
  }
  return out;
}
function Iterator_0(hasNext, next) {
  return new Iterator$1(hasNext, next);
}
var Companion_instance_7;
function Companion_getInstance_7() {
  return Companion_instance_7;
}
function Pool$_init_$lambda_q3cbhr(it) {
  return Unit_instance;
}
function Pool$_init_$lambda_q3cbhr_0(it) {
  return Unit_instance;
}
function ConcurrentPool$_init_$lambda_gqhtk8(it) {
  return Unit_instance;
}
function ReturnablePool$_init_$lambda_rsm60r(it) {
  return Unit_instance;
}
function ReturnablePool$list$lambda(this$0) {
  return function (it) {
    this$0.e2y_1(it);
    return Unit_instance;
  };
}
function ReturnablePool$list$lambda_0(this$0) {
  return function (it) {
    return this$0.f2y_1(it);
  };
}
var Companion_instance_8;
function Companion_getInstance_8() {
  return Companion_instance_8;
}
function _set_value__lx0xdg(_this__u8e3s4, $this, value) {
  $this.o2y_1[_PriorityQueueNode___get_index__impl__b6r7i5(_this__u8e3s4)] = value;
}
function _get_value__a43j40(_this__u8e3s4, $this) {
  return $this.o2y_1[_PriorityQueueNode___get_index__impl__b6r7i5(_this__u8e3s4)];
}
function _get_isRoot__1006zj(_this__u8e3s4, $this) {
  return _PriorityQueueNode___get_index__impl__b6r7i5(_this__u8e3s4) === 0;
}
function _get_parent__oo9xup(_this__u8e3s4, $this) {
  return _PriorityQueueNode___init__impl__34dlfu((_PriorityQueueNode___get_index__impl__b6r7i5(_this__u8e3s4) - 1 | 0) / 2 | 0);
}
function _get_left__d9qyp0(_this__u8e3s4, $this) {
  return _PriorityQueueNode___init__impl__34dlfu(imul(2, _PriorityQueueNode___get_index__impl__b6r7i5(_this__u8e3s4)) + 1 | 0);
}
function _get_right__bvz45n(_this__u8e3s4, $this) {
  return _PriorityQueueNode___init__impl__34dlfu(imul(2, _PriorityQueueNode___get_index__impl__b6r7i5(_this__u8e3s4)) + 2 | 0);
}
function gt($this, a, b) {
  return $this.p2y_1.compare(a, b) > 0;
}
function lt($this, a, b) {
  return $this.p2y_1.compare(a, b) < 0;
}
function _get_capacity__a9k9f3_1($this) {
  return $this.o2y_1.length;
}
function ensure_1($this, index) {
  if (index >= _get_capacity__a9k9f3_1($this)) {
    var tmp = $this;
    var tmp_0 = copyOf_2($this.o2y_1, 2 + imul(_get_capacity__a9k9f3_1($this), 2) | 0);
    tmp.o2y_1 = isArray(tmp_0) ? tmp_0 : THROW_CCE();
  }
}
function minHeapify($this, index) {
  var i = _PriorityQueueNode___init__impl__34dlfu(index);
  $l$loop: while (true) {
    var left = _get_left__d9qyp0(i, $this);
    var right = _get_right__bvz45n(i, $this);
    var smallest = i;
    if (_PriorityQueueNode___get_index__impl__b6r7i5(left) < $this.q2y_1 && lt($this, _get_value__a43j40(left, $this), _get_value__a43j40(i, $this)))
      smallest = left;
    if (_PriorityQueueNode___get_index__impl__b6r7i5(right) < $this.q2y_1 && lt($this, _get_value__a43j40(right, $this), _get_value__a43j40(smallest, $this)))
      smallest = right;
    if (!(smallest === i)) {
      swap_0($this, i, smallest);
      i = smallest;
    } else {
      break $l$loop;
    }
  }
}
function swap_0($this, l, r) {
  var temp = _get_value__a43j40(r, $this);
  _set_value__lx0xdg(r, $this, _get_value__a43j40(l, $this));
  _set_value__lx0xdg(l, $this, temp);
}
function _PriorityQueueNode___init__impl__34dlfu(index) {
  return index;
}
function _PriorityQueueNode___get_index__impl__b6r7i5($this) {
  return $this;
}
function Ref(value) {
  // Inline function 'kotlin.also' call
  var this_0 = Ref_0();
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.datastructure.Ref.<anonymous>' call
  this_0.z2y(value);
  return this_0;
}
function toRef(_this__u8e3s4) {
  return Ref_1(_this__u8e3s4);
}
function Ref_0() {
  return new Ref$1();
}
function Ref_1(prop) {
  return new Ref$2(prop);
}
function _TGenStack___init__impl__yynjgt(items) {
  items = items === VOID ? FastArrayList.j11() : items;
  return items;
}
function _get_items__fzd5gv($this) {
  return $this;
}
function _TGenStack___get_size__impl__cvg66t($this) {
  return _get_items__fzd5gv($this).e1();
}
function TGenStack__isEmpty_impl_bsbpyi($this) {
  return _TGenStack___get_size__impl__cvg66t($this) === 0;
}
var Companion_instance_9;
function Companion_getInstance_9() {
  return Companion_instance_9;
}
function TGenStack__push_impl_9yh33t($this, v) {
  _get_items__fzd5gv($this).h(v);
}
function TGenStack__pop_impl_qisxa0($this) {
  return _get_items__fzd5gv($this).r3(_get_items__fzd5gv($this).e1() - 1 | 0);
}
function TGenStack__clear_impl_pali4s($this) {
  _get_items__fzd5gv($this).m3();
}
function TGenStack__containsAll_impl_ic9i7r($this, elements) {
  return _get_items__fzd5gv($this).a3(elements);
}
function TGenStack__containsAll_impl_ic9i7r_0($this, elements) {
  return TGenStack__containsAll_impl_ic9i7r($this.d2z_1, elements);
}
function TGenStack__iterator_impl_2pdia5($this) {
  return _get_items__fzd5gv($this).a1();
}
function TGenStack__toString_impl_s9t5hn($this) {
  return 'TGenStack(items=' + $this.toString() + ')';
}
function TGenStack__hashCode_impl_l04zom($this) {
  return $this.hashCode();
}
function TGenStack__equals_impl_w9i35u($this, other) {
  if (!(other instanceof TGenStack))
    return false;
  var tmp0_other_with_cast = other instanceof TGenStack ? other.d2z_1 : THROW_CCE();
  if (!$this.equals(tmp0_other_with_cast))
    return false;
  return true;
}
function contentHashCode_2(_this__u8e3s4, src, dst) {
  // Inline function 'korlibs.datastructure.internal.hashCoder' call
  var count = dst - src | 0;
  var out = 0;
  var inductionVariable = 0;
  if (inductionVariable < count)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      out = imul(out, 7);
      var tmp = out;
      // Inline function 'korlibs.datastructure.internal.contentHashCode.<anonymous>' call
      out = tmp + toRawBits(_this__u8e3s4[src + n | 0]) | 0;
    }
     while (inductionVariable < count);
  return out;
}
function contentEquals_2(_this__u8e3s4, that, src, dst) {
  var tmp$ret$1;
  $l$block: {
    // Inline function 'korlibs.datastructure.internal.equaler' call
    var count = dst - src | 0;
    var inductionVariable = 0;
    if (inductionVariable < count)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'korlibs.datastructure.internal.contentEquals.<anonymous>' call
        if (!(_this__u8e3s4[src + n | 0] === that[src + n | 0])) {
          tmp$ret$1 = false;
          break $l$block;
        }
      }
       while (inductionVariable < count);
    tmp$ret$1 = true;
  }
  return tmp$ret$1;
}
function contentHashCode_3(_this__u8e3s4, src, dst) {
  // Inline function 'korlibs.datastructure.internal.hashCoder' call
  var count = dst - src | 0;
  var out = 0;
  var inductionVariable = 0;
  if (inductionVariable < count)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      out = imul(out, 7);
      var tmp = out;
      // Inline function 'korlibs.datastructure.internal.contentHashCode.<anonymous>' call
      out = tmp + _this__u8e3s4[src + n | 0] | 0;
    }
     while (inductionVariable < count);
  return out;
}
function contentEquals_3(_this__u8e3s4, that, src, dst) {
  var tmp$ret$1;
  $l$block: {
    // Inline function 'korlibs.datastructure.internal.equaler' call
    var count = dst - src | 0;
    var inductionVariable = 0;
    if (inductionVariable < count)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'korlibs.datastructure.internal.contentEquals.<anonymous>' call
        if (!(_this__u8e3s4[src + n | 0] === that[src + n | 0])) {
          tmp$ret$1 = false;
          break $l$block;
        }
      }
       while (inductionVariable < count);
    tmp$ret$1 = true;
  }
  return tmp$ret$1;
}
function contentHashCode_4(_this__u8e3s4, src, dst) {
  // Inline function 'korlibs.datastructure.internal.hashCoder' call
  var count = dst - src | 0;
  var out = 0;
  var inductionVariable = 0;
  if (inductionVariable < count)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      out = imul(out, 7);
      var tmp = out;
      // Inline function 'korlibs.datastructure.internal.contentHashCode.<anonymous>' call
      out = tmp + numberToInt(_this__u8e3s4[src + n | 0]) | 0;
    }
     while (inductionVariable < count);
  return out;
}
function contentEquals_4(_this__u8e3s4, that, src, dst) {
  var tmp$ret$1;
  $l$block: {
    // Inline function 'korlibs.datastructure.internal.equaler' call
    var count = dst - src | 0;
    var inductionVariable = 0;
    if (inductionVariable < count)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'korlibs.datastructure.internal.contentEquals.<anonymous>' call
        if (!(_this__u8e3s4[src + n | 0] === that[src + n | 0])) {
          tmp$ret$1 = false;
          break $l$block;
        }
      }
       while (inductionVariable < count);
    tmp$ret$1 = true;
  }
  return tmp$ret$1;
}
function fill(_this__u8e3s4, value) {
  var inductionVariable = 0;
  var last = _this__u8e3s4.length - 1 | 0;
  if (inductionVariable <= last)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      _this__u8e3s4[n] = value;
    }
     while (inductionVariable <= last);
}
function linkedHashMapOf(pairs) {
  // Inline function 'kotlin.also' call
  var this_0 = LinkedHashMap.rc();
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.datastructure.linkedHashMapOf.<anonymous>' call
  var inductionVariable = 0;
  var last = pairs.length;
  while (inductionVariable < last) {
    var _destruct__k2r9zo = pairs[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    var key = _destruct__k2r9zo.ul();
    var value = _destruct__k2r9zo.vl();
    // Inline function 'kotlin.collections.set' call
    this_0.j3(key, value);
  }
  return this_0;
}
function _BSearchResult___init__impl__em6zam(raw) {
  return raw;
}
function _BSearchResult___get_raw__impl__uyuhf3($this) {
  return $this;
}
function _BSearchResult___get_found__impl__om04iz($this) {
  return _BSearchResult___get_raw__impl__uyuhf3($this) >= 0;
}
function _BSearchResult___get_index__impl__b5kraz($this) {
  return _BSearchResult___get_found__impl__om04iz($this) ? _BSearchResult___get_raw__impl__uyuhf3($this) : -1;
}
function _BSearchResult___get_nearIndex__impl__s8nq43($this) {
  return _BSearchResult___get_found__impl__om04iz($this) ? _BSearchResult___get_raw__impl__uyuhf3($this) : (-_BSearchResult___get_raw__impl__uyuhf3($this) | 0) - 1 | 0;
}
function binarySearch(_this__u8e3s4, v, fromIndex, toIndex) {
  fromIndex = fromIndex === VOID ? 0 : fromIndex;
  toIndex = toIndex === VOID ? _this__u8e3s4.e1() : toIndex;
  // Inline function 'korlibs.datastructure.genericBinarySearchResult' call
  var tmp$ret$1;
  $l$block: {
    // Inline function 'korlibs.datastructure.genericBinarySearch' call
    var low = fromIndex;
    var high = toIndex - 1 | 0;
    while (low <= high) {
      var mid = (low + high | 0) / 2 | 0;
      // Inline function 'korlibs.datastructure.binarySearch.<anonymous>' call
      var mval = compareTo(_this__u8e3s4.m10(mid), v);
      if (mval < 0)
        low = mid + 1 | 0;
      else if (mval > 0)
        high = mid - 1 | 0;
      else {
        tmp$ret$1 = mid;
        break $l$block;
      }
    }
    // Inline function 'korlibs.datastructure.genericBinarySearchResult.<anonymous>' call
    tmp$ret$1 = (-low | 0) - 1 | 0;
  }
  return _BSearchResult___init__impl__em6zam(tmp$ret$1);
}
function getCyclic(_this__u8e3s4, index) {
  return _this__u8e3s4.d1(umod(index, _this__u8e3s4.e1()));
}
function toLinkedMap(_this__u8e3s4) {
  // Inline function 'kotlin.also' call
  var this_0 = LinkedHashMap.rc();
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.datastructure.toLinkedMap.<anonymous>' call
  var _iterator__ex2g4s = _this__u8e3s4.a1();
  while (_iterator__ex2g4s.b1()) {
    var _destruct__k2r9zo = _iterator__ex2g4s.c1();
    var key = _destruct__k2r9zo.ul();
    var value = _destruct__k2r9zo.vl();
    // Inline function 'kotlin.collections.set' call
    this_0.j3(key, value);
  }
  return this_0;
}
function getCyclic_0(_this__u8e3s4, index) {
  return _this__u8e3s4[umod(index, _this__u8e3s4.length)];
}
function genericSort(subject, left, right, ops) {
  return genericSort_0(subject, left, right, ops, false);
}
function genericSort_0(subject, left, right, ops, reversed) {
  // Inline function 'kotlin.also' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.datastructure.genericSort.<anonymous>' call
  timSort(subject, left, right, ops, reversed);
  return subject;
}
function timSort(arr, l, r, ops, reversed, RUN) {
  RUN = RUN === VOID ? 32 : RUN;
  var n = (r - l | 0) + 1 | 0;
  var progression = step(until(0, n), RUN);
  var inductionVariable = progression.d2_1;
  var last = progression.e2_1;
  var step_0 = progression.f2_1;
  if (step_0 > 0 && inductionVariable <= last || (step_0 < 0 && last <= inductionVariable))
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + step_0 | 0;
      var tmp = l + i | 0;
      // Inline function 'kotlin.math.min' call
      var a = (i + RUN | 0) - 1 | 0;
      var b = n - 1 | 0;
      var tmp$ret$0 = Math.min(a, b);
      insertionSort(arr, tmp, l + tmp$ret$0 | 0, ops, reversed);
    }
     while (!(i === last));
  var size = RUN;
  while (size < n) {
    var progression_0 = step(until(0, n), imul(2, size));
    var inductionVariable_0 = progression_0.d2_1;
    var last_0 = progression_0.e2_1;
    var step_1 = progression_0.f2_1;
    if (step_1 > 0 && inductionVariable_0 <= last_0 || (step_1 < 0 && last_0 <= inductionVariable_0))
      do {
        var left = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + step_1 | 0;
        // Inline function 'kotlin.math.min' call
        var a_0 = size;
        var b_0 = (n - left | 0) - 1 | 0;
        var rize = Math.min(a_0, b_0);
        var mid = (left + rize | 0) - 1 | 0;
        // Inline function 'kotlin.math.min' call
        var a_1 = (left + imul(2, rize) | 0) - 1 | 0;
        var b_1 = n - 1 | 0;
        var right = Math.min(a_1, b_1);
        merge(arr, l + left | 0, l + mid | 0, l + right | 0, ops, reversed);
      }
       while (!(left === last_0));
    size = imul(size, 2);
  }
}
function insertionSort(arr, left, right, ops, reversed) {
  var inductionVariable = left + 1 | 0;
  if (inductionVariable <= right)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var m = n - 1 | 0;
      $l$loop: while (m >= left && negateIf(ops.q2t(arr, m, n), reversed) > 0) {
        m = m - 1 | 0;
      }
      m = m + 1 | 0;
      if (!(m === n)) {
        ops.t2t(arr, m, n);
      }
    }
     while (!(n === right));
}
function merge(arr, start, mid, end, ops, reversed) {
  var s = start;
  var m = mid;
  var s2 = m + 1 | 0;
  if (negateIf(ops.q2t(arr, m, s2), reversed) <= 0)
    return Unit_instance;
  while (s <= m && s2 <= end) {
    if (negateIf(ops.q2t(arr, s, s2), reversed) <= 0) {
      s = s + 1 | 0;
    } else {
      ops.t2t(arr, s, s2);
      s = s + 1 | 0;
      m = m + 1 | 0;
      s2 = s2 + 1 | 0;
    }
  }
}
function negateIf(_this__u8e3s4, doNegate) {
  return doNegate ? -_this__u8e3s4 | 0 : _this__u8e3s4;
}
var Memory_instance;
function Memory_getInstance() {
  return Memory_instance;
}
var Companion_instance_10;
function Companion_getInstance_10() {
  return Companion_instance_10;
}
function index($this, index, offset) {
  return imul(index, 2) + offset | 0;
}
function pointArrayListOf(p0, p1) {
  return (new PointArrayList(2)).q2z(p0).q2z(p1);
}
function pointArrayListOf_0(p0, p1, p2) {
  return (new PointArrayList(3)).q2z(p0).q2z(p1).q2z(p2);
}
function pointArrayListOf_1(p0, p1, p2, p3) {
  return (new PointArrayList(4)).q2z(p0).q2z(p1).q2z(p2).q2z(p3);
}
function toPointArrayList(_this__u8e3s4) {
  // Inline function 'kotlin.also' call
  var this_0 = new PointArrayList(_this__u8e3s4.e1());
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.math.geom.toPointArrayList.<anonymous>' call
  var _iterator__ex2g4s = _this__u8e3s4.a1();
  while (_iterator__ex2g4s.b1()) {
    var p = _iterator__ex2g4s.c1();
    this_0.q2z(p);
  }
  return this_0;
}
function checkDimensions($this, dim) {
  if (!(dim === $this.w2z_1)) {
    // Inline function 'kotlin.error' call
    var message = 'Invalid dimensions ' + dim + ' != ' + $this.w2z_1;
    throw IllegalStateException.l5(toString(message));
  }
}
function DoubleVectorArrayList$vectorToStringBuilder$lambda(this$0, $index, $roundDecimalPlaces) {
  return function ($this$appendGenericArray, it) {
    var v = this$0.s2f($index, it);
    appendNice($this$appendGenericArray, !($roundDecimalPlaces == null) ? roundDecimalPlaces(v, $roundDecimalPlaces) : v);
    return Unit_instance;
  };
}
var Companion_instance_11;
function Companion_getInstance_11() {
  return Companion_instance_11;
}
function FastStringMap() {
  // Inline function 'kotlin.js.asDynamic' call
  return new Map();
}
function FastIntMap() {
  // Inline function 'kotlin.js.asDynamic' call
  return new Map();
}
function get_size(_this__u8e3s4) {
  // Inline function 'kotlin.js.asDynamic' call
  return _this__u8e3s4.size;
}
function FastIdentityMap() {
  // Inline function 'kotlin.js.asDynamic' call
  return new Map();
}
function contains(_this__u8e3s4, key) {
  // Inline function 'kotlin.js.asDynamic' call
  return _this__u8e3s4.has(key);
}
function clear(_this__u8e3s4) {
  // Inline function 'kotlin.js.asDynamic' call
  _this__u8e3s4.clear();
}
function get_size_0(_this__u8e3s4) {
  // Inline function 'kotlin.js.asDynamic' call
  return _this__u8e3s4.size;
}
function get_2(_this__u8e3s4, key) {
  // Inline function 'kotlin.js.asDynamic' call
  return _this__u8e3s4.get(key);
}
function set_1(_this__u8e3s4, key, value) {
  // Inline function 'kotlin.js.asDynamic' call
  _this__u8e3s4.set(key, value);
}
function remove(_this__u8e3s4, key) {
  // Inline function 'kotlin.js.asDynamic' call
  _this__u8e3s4.delete(key);
}
function keys(_this__u8e3s4) {
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = Array_from(_this__u8e3s4.keys());
  return toList_0(tmp$ret$2);
}
function Array_from(value) {
  return Array.from(value);
}
//region block: post-declaration
initMetadataForCompanion(Companion);
initMetadataForInterface(IArray2, 'IArray2', VOID, VOID, [Iterable]);
initMetadataForInterface(IntIArray2, 'IntIArray2', VOID, VOID, [IArray2]);
protoOf(IntArray2).s2f = get;
protoOf(IntArray2).d2q = set;
protoOf(IntArray2).m10 = getAt_0;
protoOf(IntArray2).e2q = getAt;
protoOf(IntArray2).f2q = inside;
protoOf(IntArray2).c2q = asString;
initMetadataForClass(IntArray2, 'IntArray2', VOID, VOID, [IntIArray2]);
initMetadataForCompanion(Companion_0);
initMetadataForInterface(FloatIArray2, 'FloatIArray2', VOID, VOID, [IArray2]);
protoOf(FloatArray2).s2f = get_0;
protoOf(FloatArray2).k2q = set_0;
protoOf(FloatArray2).m10 = getAt_1;
protoOf(FloatArray2).e2q = getAt;
protoOf(FloatArray2).f2q = inside;
protoOf(FloatArray2).c2q = asString;
initMetadataForClass(FloatArray2, 'FloatArray2', VOID, VOID, [FloatIArray2]);
initMetadataForClass(ByteArrayDeque, 'ByteArrayDeque', ByteArrayDeque);
initMetadataForClass(ShortArrayDeque, 'ShortArrayDeque', ShortArrayDeque);
initMetadataForCompanion(Companion_1);
initMetadataForClass(FloatArrayList, 'FloatArrayList', FloatArrayList.v2r, VOID, [Collection]);
initMetadataForCompanion(Companion_2);
initMetadataForClass(IntArrayList, 'IntArrayList', IntArrayList.g2s, VOID, [Collection]);
initMetadataForCompanion(Companion_3);
protoOf(DoubleArrayList).c3 = listIterator;
initMetadataForClass(DoubleArrayList, 'DoubleArrayList', DoubleArrayList.a2t, VOID, [DoubleList]);
initMetadataForClass(SortOps, 'SortOps');
initMetadataForObject(DoubleArrayListSortOps, 'DoubleArrayListSortOps');
initMetadataForClass(TGenDeque$iterator$1);
initMetadataForClass(TGenDeque, 'TGenDeque', TGenDeque.c2u, VOID, [MutableIterable, Collection]);
initMetadataForClass(IntDeque$iterator$1);
initMetadataForClass(IntDeque, 'IntDeque', IntDeque.u2u, VOID, [MutableIterable, Collection]);
initMetadataForClass(FastSmallSet, 'FastSmallSet', FastSmallSet.f2v);
initMetadataForClass(GenericSubList, 'GenericSubList', VOID, VOID, [KtList]);
initMetadataForClass(GenericListIterator, 'GenericListIterator');
initMetadataForCompanion(Companion_4);
initMetadataForCompanion(Companion_5);
initMetadataForClass(Entry, 'Entry');
initMetadataForClass(Iterator, 'Iterator');
initMetadataForClass(_no_name_provided__qut3iv, VOID, VOID, VOID, [Iterable]);
initMetadataForClass(_no_name_provided__qut3iv_0, VOID, VOID, VOID, [Iterable]);
initMetadataForClass(IntMap, 'IntMap', IntMap.p2w);
initMetadataForCompanion(Companion_6);
initMetadataForClass(IntIntMap, 'IntIntMap', IntIntMap.h2x);
initMetadataForClass(Iterator$1);
initMetadataForCompanion(Companion_7);
initMetadataForClass(Pool, 'Pool');
initMetadataForClass(ConcurrentPool, 'ConcurrentPool');
initMetadataForClass(ReturnablePool, 'ReturnablePool');
initMetadataForClass(sam$kotlin_Comparator$0, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator, FunctionAdapter]);
initMetadataForCompanion(Companion_8);
initMetadataForClass(TGenPriorityQueue$iterator$1);
initMetadataForClass(TGenPriorityQueue, 'TGenPriorityQueue', VOID, VOID, [MutableIterable, Collection]);
initMetadataForClass(TGenQueue, 'TGenQueue', TGenQueue, VOID, [Collection]);
initMetadataForClass(Ref$1);
initMetadataForClass(Ref$2);
initMetadataForClass(ByteRingBuffer, 'ByteRingBuffer');
initMetadataForClass(RingBuffer, 'RingBuffer');
initMetadataForClass(ShortRingBuffer, 'ShortRingBuffer');
initMetadataForCompanion(Companion_9);
initMetadataForClass(TGenStack, 'TGenStack', VOID, VOID, [Collection]);
initMetadataForClass(SyncPauseable, 'SyncPauseable', SyncPauseable);
initMetadataForObject(Memory, 'Memory');
initMetadataForInterface(PointList, 'PointList', VOID, VOID, [IDoubleVectorList, IPointList]);
initMetadataForCompanion(Companion_10);
protoOf(PointArrayList).o2z = clone$default;
protoOf(PointArrayList).u2f = get_dimensions;
protoOf(PointArrayList).g1 = isEmpty;
protoOf(PointArrayList).h2z = getComponentList;
protoOf(PointArrayList).i2z = getComponentList$default;
protoOf(PointArrayList).g2u = get_first;
protoOf(PointArrayList).h2u = get_last;
protoOf(PointArrayList).r2f = isNotEmpty;
protoOf(PointArrayList).t2f = isAlmostEquals;
protoOf(PointArrayList).xz = isAlmostEquals$default;
protoOf(PointArrayList).l2f = containsAll;
protoOf(PointArrayList).j2f = indexOf;
protoOf(PointArrayList).a1 = iterator;
protoOf(PointArrayList).c3 = listIterator_0;
protoOf(PointArrayList).d3 = listIterator_1;
protoOf(PointArrayList).e3 = subList;
initMetadataForClass(PointArrayList, 'PointArrayList', PointArrayList, VOID, [PointList]);
protoOf(DoubleVectorArrayList).t2f = isAlmostEquals;
protoOf(DoubleVectorArrayList).xz = isAlmostEquals$default;
initMetadataForClass(DoubleVectorArrayList, 'DoubleVectorArrayList', VOID, VOID, [IDoubleVectorList]);
initMetadataForCompanion(Companion_11);
initMetadataForClass(PointIntArrayList, 'PointIntArrayList', PointIntArrayList);
//endregion
//region block: init
Companion_instance = new Companion();
Companion_instance_0 = new Companion_0();
Companion_instance_1 = new Companion_1();
Companion_instance_2 = new Companion_2();
Companion_instance_3 = new Companion_3();
Companion_instance_4 = new Companion_4();
Companion_instance_5 = new Companion_5();
Companion_instance_6 = new Companion_6();
Companion_instance_7 = new Companion_7();
Companion_instance_8 = new Companion_8();
Companion_instance_9 = new Companion_9();
Memory_instance = new Memory();
Companion_instance_10 = new Companion_10();
Companion_instance_11 = new Companion_11();
//endregion
//region block: exports
export {
  _BSearchResult___init__impl__em6zam as _BSearchResult___init__impl__em6zam3kgjdixysmohf,
  _BSearchResult___get_found__impl__om04iz as _BSearchResult___get_found__impl__om04iz3bh6o9yjop0o,
  _BSearchResult___get_index__impl__b5kraz as _BSearchResult___get_index__impl__b5kraz2d2rlh08ytgci,
  _BSearchResult___get_nearIndex__impl__s8nq43 as _BSearchResult___get_nearIndex__impl__s8nq431w00iur5bsqs2,
  _TGenStack___init__impl__yynjgt as _TGenStack___init__impl__yynjgt2kqnbzr6sil9y,
  TGenStack__pop_impl_qisxa0 as TGenStack__pop_impl_qisxa01c9hqlgdxaps5,
  TGenStack__push_impl_9yh33t as TGenStack__push_impl_9yh33t21dxxdiycat5m,
  Companion_instance_0 as Companion_instance3ldriv9x4zcjm,
  Companion_instance as Companion_instancelqpzd9anuk16,
  Companion_instance_8 as Companion_instance2r8kc48nhvjcq,
  SyncPauseable as SyncPauseable20rt0nt3umu2s,
  ByteArrayDeque as ByteArrayDeque2dezgzzyyl6zm,
  ConcurrentPool as ConcurrentPool3ky1e4r5za9ab,
  DoubleArrayList as DoubleArrayList3by0we6lhx26x,
  FastIdentityMap as FastIdentityMap17d14y8i3m5g7,
  FastIntMap as FastIntMapl0pzyavg6uw5,
  FastSmallSet as FastSmallSet2og2j8v2pz4c7,
  FastStringMap as FastStringMap1l1uzdhsfbatm,
  FloatArray2 as FloatArray2beehiaucxmzd,
  GenericListIterator as GenericListIterator397gjg9p2xwl5,
  GenericSubList as GenericSubList2rec7qqyf06nw,
  IntArray2 as IntArray23680o40e0fgt8,
  IntArrayList as IntArrayList3liuagbdnwmna,
  IntDeque as IntDeque2ebok66x2sofm,
  IntIntMap as IntIntMap3mvg5iqgd5t3z,
  IntMap as IntMap2d9g6f5pyaoc2,
  Pool as Pool1zbsw0zhvh8ca,
  Ref_0 as Ref11k43t82thcp3,
  Ref as Ref2y4j4snnxo6gs,
  ReturnablePool as ReturnablePool3rkgvxsckx2u2,
  ShortArrayDeque as ShortArrayDeque13dn2tr6asm80,
  SortOps as SortOps3rp25tm4jbjru,
  TGenQueue as TGenQueue2v9j3ju90xgpv,
  associateByInt as associateByInt3vmv30txx5avl,
  binarySearch as binarySearch1lxbagta5e4q4,
  clear as clear3idbm40uzyume,
  contains as containsrsn76oa0puwr,
  doubleArrayListOf as doubleArrayListOfkj3z9zq4pobs,
  floatArrayListOf as floatArrayListOfa8snvg2p0fhc,
  genericSort as genericSort3vhmyxbppxo3h,
  getAndRemove as getAndRemove1ksxnnren48mb,
  getCyclic_0 as getCyclic18d9063nmuul,
  getCyclic as getCyclic28wvgqye98jqx,
  get_2 as get2pw1zlgv5zypd,
  intArrayListOf as intArrayListOf18h0hna7wb0zr,
  get_keys as get_keyswqddktl7cnu2,
  linkedHashMapOf as linkedHashMapOf2w2uhgrq4khrk,
  reverse_0 as reverse22fe0u1pwl2c6,
  rotateRight as rotateRight96vk8nw2c6nx,
  set_1 as set2vuztm9k7ubgo,
  get_size_0 as get_size2tttv7g2u748n,
  get_size as get_size3oaoh8cpamcqc,
  sort as sort23bpsawysis6n,
  swap as swap3upf401qn4fc8,
  toIntArrayList as toIntArrayList3jlt4o6tyleu,
  toIntMap as toIntMapp1jij98esrcm,
  toRef as toRef3av6zm8yavumw,
  DoubleVectorArrayList as DoubleVectorArrayListq54dfthnqi2t,
  PointArrayList as PointArrayList281mrsgyr6ua1,
  PointIntArrayList as PointIntArrayList1s7gare9hr1oh,
  pointArrayListOf_1 as pointArrayListOf36sb9r6prgwk4,
  pointArrayListOf_0 as pointArrayListOf2s9je3njyg83l,
  pointArrayListOf as pointArrayListOf7rbgdbqf3x4b,
  toPointArrayList as toPointArrayList14rs370f0lt8w,
};
//endregion
